/* eslint-disable */
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */
/** @typedef {{}} ActiveInputs */
/** @typedef {{}} Active_SubInputs */
/** @typedef {{}} ActivityInputs */
/** @typedef {{}} Activity_EmptyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Activity_Empty_PersonInputs */
/** @typedef {{}} Add_ChoreInputs */
/** @typedef {{}} Add_Home_FirstInputs */
/** @typedef {{ count: NonNullable<unknown> }} Ago_DaysInputs */
/** @typedef {{ count: NonNullable<unknown> }} Ago_HoursInputs */
/** @typedef {{ count: NonNullable<unknown> }} Ago_MinutesInputs */
/** @typedef {{}} Ago_NowInputs */
/** @typedef {{}} AnyoneInputs */
/** @typedef {{}} App_TaglineInputs */
/** @typedef {{}} BackInputs */
/** @typedef {{}} Badge_Bonus10_DescInputs */
/** @typedef {{}} Badge_Bonus10_NameInputs */
/** @typedef {{}} Badge_Bonus_DescInputs */
/** @typedef {{}} Badge_Bonus_NameInputs */
/** @typedef {{}} Badge_Done10_DescInputs */
/** @typedef {{}} Badge_Done10_NameInputs */
/** @typedef {{}} Badge_Done250_DescInputs */
/** @typedef {{}} Badge_Done250_NameInputs */
/** @typedef {{}} Badge_Done50_DescInputs */
/** @typedef {{}} Badge_Done50_NameInputs */
/** @typedef {{}} Badge_Early_DescInputs */
/** @typedef {{}} Badge_Early_NameInputs */
/** @typedef {{}} Badge_First_DescInputs */
/** @typedef {{}} Badge_First_NameInputs */
/** @typedef {{}} Badge_Freeze_DescInputs */
/** @typedef {{}} Badge_Freeze_NameInputs */
/** @typedef {{}} Badge_Level10_DescInputs */
/** @typedef {{}} Badge_Level10_NameInputs */
/** @typedef {{}} Badge_Level5_DescInputs */
/** @typedef {{}} Badge_Level5_NameInputs */
/** @typedef {{}} Badge_Night_DescInputs */
/** @typedef {{}} Badge_Night_NameInputs */
/** @typedef {{}} Badge_Rare_DescInputs */
/** @typedef {{}} Badge_Rare_NameInputs */
/** @typedef {{}} Badge_Rescue_DescInputs */
/** @typedef {{}} Badge_Rescue_NameInputs */
/** @typedef {{}} Badge_Room_DescInputs */
/** @typedef {{}} Badge_Room_NameInputs */
/** @typedef {{}} Badge_Stickers10_DescInputs */
/** @typedef {{}} Badge_Stickers10_NameInputs */
/** @typedef {{}} Badge_Streak100_DescInputs */
/** @typedef {{}} Badge_Streak100_NameInputs */
/** @typedef {{}} Badge_Streak30_DescInputs */
/** @typedef {{}} Badge_Streak30_NameInputs */
/** @typedef {{}} Badge_Streak3_DescInputs */
/** @typedef {{}} Badge_Streak3_NameInputs */
/** @typedef {{}} Badge_Streak7_DescInputs */
/** @typedef {{}} Badge_Streak7_NameInputs */
/** @typedef {{}} Badge_Team_DescInputs */
/** @typedef {{}} Badge_Team_NameInputs */
/** @typedef {{}} BadgesInputs */
/** @typedef {{}} Big_JobInputs */
/** @typedef {{}} Big_JobsInputs */
/** @typedef {{}} BonusInputs */
/** @typedef {{}} Break_BodyInputs */
/** @typedef {{ count: NonNullable<unknown> }} Break_DaysInputs */
/** @typedef {{}} Break_EndInputs */
/** @typedef {{ date: NonNullable<unknown> }} Break_EndsInputs */
/** @typedef {{}} Break_How_LongInputs */
/** @typedef {{}} Break_ReassureInputs */
/** @typedef {{}} Break_SickInputs */
/** @typedef {{}} Break_Sick_TitleInputs */
/** @typedef {{}} Break_TitleInputs */
/** @typedef {{}} Break_TodayInputs */
/** @typedef {{}} Break_Two_WeeksInputs */
/** @typedef {{ date: NonNullable<unknown> }} Break_UntilInputs */
/** @typedef {{}} Break_VacationInputs */
/** @typedef {{}} Break_WeekInputs */
/** @typedef {{}} Break_WeekendInputs */
/** @typedef {{}} BuyInputs */
/** @typedef {{ price: NonNullable<unknown>, pet: NonNullable<unknown> }} Buy_Confirm_BodyInputs */
/** @typedef {{ item: NonNullable<unknown> }} Buy_Confirm_TitleInputs */
/** @typedef {{}} Calendar_BreakInputs */
/** @typedef {{}} Calendar_CopiedInputs */
/** @typedef {{}} Calendar_CopyInputs */
/** @typedef {{}} Calendar_CreateInputs */
/** @typedef {{ chore: NonNullable<unknown> }} Calendar_DoneInputs */
/** @typedef {{}} Calendar_GoogleInputs */
/** @typedef {{}} Calendar_GuestsInputs */
/** @typedef {{}} Calendar_IntroInputs */
/** @typedef {{}} Calendar_LinkedInputs */
/** @typedef {{ minutes: NonNullable<unknown> }} Calendar_MinutesInputs */
/** @typedef {{ household: NonNullable<unknown> }} Calendar_NameInputs */
/** @typedef {{}} Calendar_OpenInputs */
/** @typedef {{}} Calendar_PrivateInputs */
/** @typedef {{}} Calendar_ResetInputs */
/** @typedef {{}} Calendar_Row_OnInputs */
/** @typedef {{}} Calendar_Row_SubInputs */
/** @typedef {{}} Calendar_StopInputs */
/** @typedef {{}} Calendar_TitleInputs */
/** @typedef {{}} Calendar_YoursInputs */
/** @typedef {{}} CancelInputs */
/** @typedef {{}} Chore_AddedInputs */
/** @typedef {{}} Chore_AquariumInputs */
/** @typedef {{}} Chore_BalconyInputs */
/** @typedef {{}} Chore_Bath_MatsInputs */
/** @typedef {{}} Chore_Bathroom_FloorInputs */
/** @typedef {{}} Chore_Bathroom_SinkInputs */
/** @typedef {{}} Chore_BathtubInputs */
/** @typedef {{}} Chore_BinInputs */
/** @typedef {{}} Chore_Bird_CageInputs */
/** @typedef {{}} Chore_CabinetsInputs */
/** @typedef {{}} Chore_CageInputs */
/** @typedef {{}} Chore_CurtainsInputs */
/** @typedef {{}} Chore_Descale_KettleInputs */
/** @typedef {{}} Chore_DeskInputs */
/** @typedef {{}} Chore_Dining_TableInputs */
/** @typedef {{}} Chore_Dishwasher_FilterInputs */
/** @typedef {{}} Chore_DoorsInputs */
/** @typedef {{}} Chore_DrawerInputs */
/** @typedef {{}} Chore_Dryer_LintInputs */
/** @typedef {{}} Chore_DustInputs */
/** @typedef {{}} Chore_FansInputs */
/** @typedef {{}} Chore_FreezerInputs */
/** @typedef {{}} Chore_Fridge_ClearoutInputs */
/** @typedef {{}} Chore_Fridge_DeepInputs */
/** @typedef {{}} Chore_GarageInputs */
/** @typedef {{}} Chore_Garden_FurnitureInputs */
/** @typedef {{}} Chore_GroutInputs */
/** @typedef {{}} Chore_Guest_RoomInputs */
/** @typedef {{}} Chore_GuttersInputs */
/** @typedef {{}} Chore_HallwayInputs */
/** @typedef {{}} Chore_Hood_FilterInputs */
/** @typedef {{}} Chore_Kitchen_SinkInputs */
/** @typedef {{}} Chore_Laundry_RoomInputs */
/** @typedef {{}} Chore_Litter_BoxInputs */
/** @typedef {{}} Chore_MattressInputs */
/** @typedef {{}} Chore_MicrowaveInputs */
/** @typedef {{}} Chore_Mop_KitchenInputs */
/** @typedef {{ n: NonNullable<unknown>, total: NonNullable<unknown> }} Chore_N_OfInputs */
/** @typedef {{}} Chore_Name_LabelInputs */
/** @typedef {{}} Chore_NightstandInputs */
/** @typedef {{}} Chore_OvenInputs */
/** @typedef {{}} Chore_PantryInputs */
/** @typedef {{}} Chore_Pet_BedInputs */
/** @typedef {{}} Chore_Pet_BowlsInputs */
/** @typedef {{}} Chore_Pet_HairInputs */
/** @typedef {{}} Chore_Pet_ToysInputs */
/** @typedef {{}} Chore_PillowsInputs */
/** @typedef {{}} Chore_PlaceholderInputs */
/** @typedef {{}} Chore_Plant_LeavesInputs */
/** @typedef {{}} Chore_PlantsInputs */
/** @typedef {{}} Chore_RadiatorsInputs */
/** @typedef {{}} Chore_RugsInputs */
/** @typedef {{}} Chore_ScreensInputs */
/** @typedef {{}} Chore_SheetsInputs */
/** @typedef {{}} Chore_ShowerInputs */
/** @typedef {{}} Chore_Shower_CurtainInputs */
/** @typedef {{}} Chore_ShowerheadInputs */
/** @typedef {{}} Chore_SkirtingInputs */
/** @typedef {{}} Chore_Smoke_AlarmsInputs */
/** @typedef {{}} Chore_SofaInputs */
/** @typedef {{}} Chore_StairsInputs */
/** @typedef {{}} Chore_StovetopInputs */
/** @typedef {{}} Chore_SwitchesInputs */
/** @typedef {{}} Chore_ToiletInputs */
/** @typedef {{}} Chore_Toilet_BasinInputs */
/** @typedef {{}} Chore_Under_BedInputs */
/** @typedef {{}} Chore_Vacuum_FilterInputs */
/** @typedef {{}} Chore_Vacuum_LivingInputs */
/** @typedef {{}} Chore_WardrobeInputs */
/** @typedef {{}} Chore_Washing_MachineInputs */
/** @typedef {{}} Chore_WeedingInputs */
/** @typedef {{}} Chore_Windows_InsideInputs */
/** @typedef {{}} Chore_Windows_OutsideInputs */
/** @typedef {{ count: NonNullable<unknown> }} Chores_CountInputs */
/** @typedef {{ count: NonNullable<unknown> }} Chores_OnInputs */
/** @typedef {{}} CleanlinessInputs */
/** @typedef {{}} CloseInputs */
/** @typedef {{}} Coins_LabelInputs */
/** @typedef {{ count: NonNullable<unknown> }} Coins_NInputs */
/** @typedef {{}} ColourInputs */
/** @typedef {{}} CompanionInputs */
/** @typedef {{}} Confirm_Delete_ChoreInputs */
/** @typedef {{ household: NonNullable<unknown> }} Confirm_LeaveInputs */
/** @typedef {{}} Confirm_Sign_OutInputs */
/** @typedef {{}} _ContinueInputs */
/** @typedef {{}} Copy_CodeInputs */
/** @typedef {{}} Crash_BodyInputs */
/** @typedef {{}} Crash_TitleInputs */
/** @typedef {{}} Create_HouseholdInputs */
/** @typedef {{}} Daily_TimeInputs */
/** @typedef {{}} Daily_Time_SubInputs */
/** @typedef {{ count: NonNullable<unknown> }} Days_OverdueInputs */
/** @typedef {{}} _DeleteInputs */
/** @typedef {{}} Delete_ChoreInputs */
/** @typedef {{ os: NonNullable<unknown> }} Device_AppInputs */
/** @typedef {{}} Device_CodeInputs */
/** @typedef {{}} Device_GenericInputs */
/** @typedef {{ browser: NonNullable<unknown>, os: NonNullable<unknown> }} Device_NameInputs */
/** @typedef {{}} DoneInputs */
/** @typedef {{}} Done_ButtonInputs */
/** @typedef {{}} Done_For_TodayInputs */
/** @typedef {{}} Dry_DayInputs */
/** @typedef {{ count: NonNullable<unknown> }} Due_In_DaysInputs */
/** @typedef {{}} Due_TodayInputs */
/** @typedef {{}} Due_TomorrowInputs */
/** @typedef {{ hours: NonNullable<unknown> }} Duration_HInputs */
/** @typedef {{ hours: NonNullable<unknown>, minutes: NonNullable<unknown> }} Duration_H_MInputs */
/** @typedef {{}} Easier_OneInputs */
/** @typedef {{}} Edit_ChoreInputs */
/** @typedef {{}} EffortInputs */
/** @typedef {{}} Effort_1Inputs */
/** @typedef {{}} Effort_2Inputs */
/** @typedef {{}} Effort_3Inputs */
/** @typedef {{}} Err_Already_DoneInputs */
/** @typedef {{}} Err_Assignment_Not_FoundInputs */
/** @typedef {{}} Err_AvatarInputs */
/** @typedef {{}} Err_Bonus_Needs_DailyInputs */
/** @typedef {{}} Err_Bonus_NoneInputs */
/** @typedef {{}} Err_Bonus_PendingInputs */
/** @typedef {{}} Err_Chore_NameInputs */
/** @typedef {{}} Err_Chore_Not_FoundInputs */
/** @typedef {{}} Err_CodeInputs */
/** @typedef {{}} Err_ForbiddenInputs */
/** @typedef {{}} Err_Freezes_FullInputs */
/** @typedef {{}} Err_FreqInputs */
/** @typedef {{}} Err_GenericInputs */
/** @typedef {{}} Err_Guests_DateInputs */
/** @typedef {{}} Err_High_Five_SelfInputs */
/** @typedef {{}} Err_Household_NameInputs */
/** @typedef {{ count: NonNullable<unknown> }} Err_Household_Too_SmallInputs */
/** @typedef {{}} Err_InvalidInputs */
/** @typedef {{}} Err_Invite_CodeInputs */
/** @typedef {{}} Err_Invite_Not_FoundInputs */
/** @typedef {{}} Err_Item_OwnedInputs */
/** @typedef {{}} Err_Link_InvalidInputs */
/** @typedef {{}} Err_Member_Not_FoundInputs */
/** @typedef {{}} Err_No_ConnectionInputs */
/** @typedef {{}} Err_No_Swap_OptionInputs */
/** @typedef {{}} Err_Not_Enough_CoinsInputs */
/** @typedef {{}} Err_Not_FoundInputs */
/** @typedef {{}} Err_Nothing_To_SwapInputs */
/** @typedef {{}} Err_OfflineInputs */
/** @typedef {{}} Err_OwnerInputs */
/** @typedef {{}} Err_Pause_PastInputs */
/** @typedef {{}} Err_Pause_Too_LongInputs */
/** @typedef {{}} Err_People_MaxInputs */
/** @typedef {{}} Err_People_MinInputs */
/** @typedef {{}} Err_Pet_NameInputs */
/** @typedef {{}} Err_Photo_InvalidInputs */
/** @typedef {{}} Err_Photo_Too_BigInputs */
/** @typedef {{}} Err_Places_UnavailableInputs */
/** @typedef {{}} Err_Project_Last_StepInputs */
/** @typedef {{}} Err_Project_NameInputs */
/** @typedef {{}} Err_Project_StepsInputs */
/** @typedef {{}} Err_Push_SubscriptionInputs */
/** @typedef {{}} Err_Rate_LimitedInputs */
/** @typedef {{}} Err_RoomInputs */
/** @typedef {{}} Err_Schedule_EmptyInputs */
/** @typedef {{}} Err_ServerInputs */
/** @typedef {{}} Err_Sign_InInputs */
/** @typedef {{}} Err_Sign_In_AgainInputs */
/** @typedef {{}} Err_Step_NameInputs */
/** @typedef {{}} Err_Supplies_FullInputs */
/** @typedef {{}} Err_Supply_NameInputs */
/** @typedef {{}} Err_Swap_UsedInputs */
/** @typedef {{}} Err_Time_FormatInputs */
/** @typedef {{}} Err_TimeoutInputs */
/** @typedef {{}} Err_Timer_MinutesInputs */
/** @typedef {{}} Err_Timers_FullInputs */
/** @typedef {{}} Err_Too_LargeInputs */
/** @typedef {{}} Err_Too_LongInputs */
/** @typedef {{}} Err_Trade_GoneInputs */
/** @typedef {{}} Err_Trade_NothingInputs */
/** @typedef {{}} Err_Trade_OwnedInputs */
/** @typedef {{}} Err_Treat_NameInputs */
/** @typedef {{}} Err_Treat_PriceInputs */
/** @typedef {{}} Err_Treats_FullInputs */
/** @typedef {{}} Err_TzInputs */
/** @typedef {{}} Err_Your_NameInputs */
/** @typedef {{}} Every_How_Many_DaysInputs */
/** @typedef {{}} EveryoneInputs */
/** @typedef {{}} ExpiredInputs */
/** @typedef {{ time: NonNullable<unknown> }} Expires_InInputs */
/** @typedef {{}} Fair_ShareInputs */
/** @typedef {{}} Fair_Share_EmptyInputs */
/** @typedef {{ days: NonNullable<unknown> }} Fair_Share_HintInputs */
/** @typedef {{}} First_Badge_HintInputs */
/** @typedef {{ sticker: NonNullable<unknown> }} Found_StickerInputs */
/** @typedef {{}} Freeze_BoughtInputs */
/** @typedef {{ price: NonNullable<unknown> }} Freeze_Confirm_BodyInputs */
/** @typedef {{}} Freeze_Confirm_TitleInputs */
/** @typedef {{}} Freeze_CoveredInputs */
/** @typedef {{}} Freeze_EarnedInputs */
/** @typedef {{}} Freeze_Earned_SubInputs */
/** @typedef {{}} Freeze_FullInputs */
/** @typedef {{}} Freeze_ItemInputs */
/** @typedef {{ count: NonNullable<unknown>, max: NonNullable<unknown> }} Freeze_Item_SubInputs */
/** @typedef {{ count: NonNullable<unknown> }} Freezes_CountInputs */
/** @typedef {{}} Freq_2monthsInputs */
/** @typedef {{}} Freq_2weeksInputs */
/** @typedef {{}} Freq_3monthsInputs */
/** @typedef {{}} Freq_CustomInputs */
/** @typedef {{}} Freq_DailyInputs */
/** @typedef {{ count: NonNullable<unknown> }} Freq_Every_DaysInputs */
/** @typedef {{ count: NonNullable<unknown> }} Freq_Every_WeeksInputs */
/** @typedef {{}} Freq_MonthlyInputs */
/** @typedef {{}} Freq_Twice_YearInputs */
/** @typedef {{}} Freq_WeeklyInputs */
/** @typedef {{}} Freq_YearlyInputs */
/** @typedef {{}} Fully_GrownInputs */
/** @typedef {{}} Furniture_AquariumInputs */
/** @typedef {{}} Furniture_BookcaseInputs */
/** @typedef {{}} Furniture_ClockInputs */
/** @typedef {{}} Furniture_CushionInputs */
/** @typedef {{}} Furniture_Disco_BallInputs */
/** @typedef {{}} Furniture_DotsInputs */
/** @typedef {{}} Furniture_Fairy_LightsInputs */
/** @typedef {{}} Furniture_Floor_LampInputs */
/** @typedef {{}} Furniture_PaintingInputs */
/** @typedef {{ pet: NonNullable<unknown>, item: NonNullable<unknown> }} Furniture_PermissionInputs */
/** @typedef {{}} Furniture_PlantInputs */
/** @typedef {{}} Furniture_RugInputs */
/** @typedef {{}} Furniture_ShelfInputs */
/** @typedef {{}} Furniture_StripesInputs */
/** @typedef {{}} Furniture_WindowInputs */
/** @typedef {{ date: NonNullable<unknown> }} Guests_BannerInputs */
/** @typedef {{}} Guests_ClearInputs */
/** @typedef {{}} Guests_IntroInputs */
/** @typedef {{ date: NonNullable<unknown> }} Guests_OnInputs */
/** @typedef {{}} Guests_PickInputs */
/** @typedef {{}} Guests_RowInputs */
/** @typedef {{}} Guests_Row_SubInputs */
/** @typedef {{}} Guests_TitleInputs */
/** @typedef {{}} Guests_TomorrowInputs */
/** @typedef {{ count: NonNullable<unknown> }} Hide_InactiveInputs */
/** @typedef {{}} High_FiveInputs */
/** @typedef {{}} High_FivedInputs */
/** @typedef {{}} HistoryInputs */
/** @typedef {{}} History_EmptyInputs */
/** @typedef {{}} Home_IntroInputs */
/** @typedef {{}} Home_Pet_BirdInputs */
/** @typedef {{}} Home_Pet_CatInputs */
/** @typedef {{}} Home_Pet_DogInputs */
/** @typedef {{}} Home_Pet_FishInputs */
/** @typedef {{}} Home_Pet_Small_PetInputs */
/** @typedef {{}} Home_SavedInputs */
/** @typedef {{}} Home_Space_BalconyInputs */
/** @typedef {{}} Home_Space_DiningInputs */
/** @typedef {{}} Home_Space_GarageInputs */
/** @typedef {{}} Home_Space_GardenInputs */
/** @typedef {{}} Home_Space_Guest_RoomInputs */
/** @typedef {{}} Home_Space_LaundryInputs */
/** @typedef {{}} Home_Space_OfficeInputs */
/** @typedef {{}} Home_Space_StairsInputs */
/** @typedef {{}} Home_Thing_BathtubInputs */
/** @typedef {{}} Home_Thing_DishwasherInputs */
/** @typedef {{}} Home_Thing_DryerInputs */
/** @typedef {{}} Home_Thing_PlantsInputs */
/** @typedef {{}} Home_TitleInputs */
/** @typedef {{}} Home_Type_ApartmentInputs */
/** @typedef {{}} Home_Type_HouseInputs */
/** @typedef {{}} HouseholdInputs */
/** @typedef {{}} Household_NameInputs */
/** @typedef {{}} Household_Name_PlaceholderInputs */
/** @typedef {{ months: NonNullable<unknown> }} In_SeasonInputs */
/** @typedef {{}} Install_BodyInputs */
/** @typedef {{}} Install_ButtonInputs */
/** @typedef {{}} Install_Done_BodyInputs */
/** @typedef {{}} Install_Done_TitleInputs */
/** @typedef {{}} Install_Invite_NoteInputs */
/** @typedef {{}} Install_Ios_1Inputs */
/** @typedef {{}} Install_Ios_2Inputs */
/** @typedef {{}} Install_OpenInputs */
/** @typedef {{}} Install_Other_1Inputs */
/** @typedef {{}} Install_Other_2Inputs */
/** @typedef {{}} Install_SkipInputs */
/** @typedef {{}} Install_TitleInputs */
/** @typedef {{}} Invite_CodeInputs */
/** @typedef {{ code: NonNullable<unknown> }} Invite_Code_ToastInputs */
/** @typedef {{}} Invite_CopiedInputs */
/** @typedef {{ household: NonNullable<unknown>, code: NonNullable<unknown> }} Invite_TextInputs */
/** @typedef {{}} Invite_WarningInputs */
/** @typedef {{}} Ios_Home_ScreenInputs */
/** @typedef {{}} Item_BeanieInputs */
/** @typedef {{}} Item_BikiniInputs */
/** @typedef {{}} Item_BowInputs */
/** @typedef {{}} Item_BroomInputs */
/** @typedef {{}} Item_FlowerInputs */
/** @typedef {{}} Item_GlassesInputs */
/** @typedef {{}} Item_Party_HatInputs */
/** @typedef {{ pet: NonNullable<unknown>, item: NonNullable<unknown> }} Item_PermissionInputs */
/** @typedef {{}} Item_ScarfInputs */
/** @typedef {{}} Item_SunglassesInputs */
/** @typedef {{}} Item_SunhatInputs */
/** @typedef {{}} JoinInputs */
/** @typedef {{}} Join_HouseholdInputs */
/** @typedef {{}} Keep_ListInputs */
/** @typedef {{}} LanguageInputs */
/** @typedef {{ language: NonNullable<unknown> }} Language_AutoInputs */
/** @typedef {{}} Last_7_DaysInputs */
/** @typedef {{ when: NonNullable<unknown> }} Last_ActiveInputs */
/** @typedef {{}} Last_DoneInputs */
/** @typedef {{ when: NonNullable<unknown>, name: NonNullable<unknown> }} Last_Done_ByInputs */
/** @typedef {{ count: NonNullable<unknown> }} Last_Done_DaysInputs */
/** @typedef {{}} Last_Done_TodayInputs */
/** @typedef {{}} Last_Done_YesterdayInputs */
/** @typedef {{}} Ld_Few_DaysInputs */
/** @typedef {{}} Ld_Few_MonthsInputs */
/** @typedef {{}} Ld_MonthInputs */
/** @typedef {{}} Ld_TodayInputs */
/** @typedef {{}} Ld_Two_WeeksInputs */
/** @typedef {{}} Ld_WeekInputs */
/** @typedef {{}} Ld_YearInputs */
/** @typedef {{}} Ld_YesterdayInputs */
/** @typedef {{}} Leave_HouseholdInputs */
/** @typedef {{ level: NonNullable<unknown> }} Level_NInputs */
/** @typedef {{}} Level_Title_0Inputs */
/** @typedef {{}} Level_Title_1Inputs */
/** @typedef {{}} Level_Title_10Inputs */
/** @typedef {{}} Level_Title_2Inputs */
/** @typedef {{}} Level_Title_3Inputs */
/** @typedef {{}} Level_Title_4Inputs */
/** @typedef {{}} Level_Title_5Inputs */
/** @typedef {{}} Level_Title_6Inputs */
/** @typedef {{}} Level_Title_7Inputs */
/** @typedef {{}} Level_Title_8Inputs */
/** @typedef {{}} Level_Title_9Inputs */
/** @typedef {{ title: NonNullable<unknown> }} Level_Up_SubInputs */
/** @typedef {{}} Link_DeviceInputs */
/** @typedef {{}} Link_Device_SubInputs */
/** @typedef {{}} Link_IntroInputs */
/** @typedef {{}} Link_Sheet_BodyInputs */
/** @typedef {{}} Link_TitleInputs */
/** @typedef {{}} Load_Error_TitleInputs */
/** @typedef {{}} LoadingInputs */
/** @typedef {{}} Mark_DoneInputs */
/** @typedef {{ name: NonNullable<unknown> }} Mark_X_DoneInputs */
/** @typedef {{ minutes: NonNullable<unknown> }} Minutes_ShortInputs */
/** @typedef {{}} Mood_GrumpyInputs */
/** @typedef {{}} Mood_HappyInputs */
/** @typedef {{}} Mood_MehInputs */
/** @typedef {{}} Mood_SadInputs */
/** @typedef {{}} Mood_ThrivingInputs */
/** @typedef {{}} NameInputs */
/** @typedef {{}} Never_MindInputs */
/** @typedef {{}} New_ChoreInputs */
/** @typedef {{}} New_CodeInputs */
/** @typedef {{}} New_HouseholdInputs */
/** @typedef {{}} New_RoomInputs */
/** @typedef {{}} Next_BadgesInputs */
/** @typedef {{}} No_Chores_AvailableInputs */
/** @typedef {{}} No_StreakInputs */
/** @typedef {{}} Not_Done_YetInputs */
/** @typedef {{}} Not_NowInputs */
/** @typedef {{}} Not_SureInputs */
/** @typedef {{}} NotesInputs */
/** @typedef {{}} Notes_HintInputs */
/** @typedef {{}} Notes_PlaceholderInputs */
/** @typedef {{}} Nothing_PickedInputs */
/** @typedef {{}} Notif_DailyInputs */
/** @typedef {{}} Notif_Daily_SubInputs */
/** @typedef {{}} Notif_RecapInputs */
/** @typedef {{}} Notif_Recap_SubInputs */
/** @typedef {{}} Notif_StreakInputs */
/** @typedef {{}} Notif_Streak_SubInputs */
/** @typedef {{}} Notif_TeamInputs */
/** @typedef {{}} Notif_Team_SubInputs */
/** @typedef {{}} NotificationsInputs */
/** @typedef {{}} OffInputs */
/** @typedef {{}} Off_This_DeviceInputs */
/** @typedef {{}} Offline_BannerInputs */
/** @typedef {{}} On_A_BreakInputs */
/** @typedef {{ count: NonNullable<unknown> }} Overdue_CountInputs */
/** @typedef {{}} PeopleInputs */
/** @typedef {{ count: NonNullable<unknown> }} People_CountInputs */
/** @typedef {{}} People_HintInputs */
/** @typedef {{}} People_QuestionInputs */
/** @typedef {{}} People_SubInputs */
/** @typedef {{ perDay: NonNullable<unknown> }} Per_Day_NeededInputs */
/** @typedef {{}} Pet_Bunny_Stage_0Inputs */
/** @typedef {{}} Pet_Bunny_Stage_1Inputs */
/** @typedef {{}} Pet_Bunny_Stage_2Inputs */
/** @typedef {{}} Pet_Bunny_Stage_3Inputs */
/** @typedef {{}} Pet_Bunny_Stage_4Inputs */
/** @typedef {{}} Pet_Bunny_Stage_5Inputs */
/** @typedef {{}} Pet_Cat_Stage_0Inputs */
/** @typedef {{}} Pet_Cat_Stage_1Inputs */
/** @typedef {{}} Pet_Cat_Stage_2Inputs */
/** @typedef {{}} Pet_Cat_Stage_3Inputs */
/** @typedef {{}} Pet_Cat_Stage_4Inputs */
/** @typedef {{}} Pet_Cat_Stage_5Inputs */
/** @typedef {{}} Pet_Chick_Stage_0Inputs */
/** @typedef {{}} Pet_Chick_Stage_1Inputs */
/** @typedef {{}} Pet_Chick_Stage_2Inputs */
/** @typedef {{}} Pet_Chick_Stage_3Inputs */
/** @typedef {{}} Pet_Chick_Stage_4Inputs */
/** @typedef {{}} Pet_Chick_Stage_5Inputs */
/** @typedef {{}} Pet_Fox_Stage_0Inputs */
/** @typedef {{}} Pet_Fox_Stage_1Inputs */
/** @typedef {{}} Pet_Fox_Stage_2Inputs */
/** @typedef {{}} Pet_Fox_Stage_3Inputs */
/** @typedef {{}} Pet_Fox_Stage_4Inputs */
/** @typedef {{}} Pet_Fox_Stage_5Inputs */
/** @typedef {{ name: NonNullable<unknown>, stage: NonNullable<unknown> }} Pet_Grew_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Pet_Grew_TitleInputs */
/** @typedef {{}} Pet_IntroInputs */
/** @typedef {{}} Pet_Kind_BunnyInputs */
/** @typedef {{}} Pet_Kind_CatInputs */
/** @typedef {{}} Pet_Kind_ChickInputs */
/** @typedef {{}} Pet_Kind_FoxInputs */
/** @typedef {{}} Pet_Kind_PupInputs */
/** @typedef {{}} Pet_Kind_SproutInputs */
/** @typedef {{}} Pet_Name_IdeasInputs */
/** @typedef {{}} Pet_Name_LabelInputs */
/** @typedef {{ name: NonNullable<unknown> }} Pet_OwnerInputs */
/** @typedef {{}} Pet_Pup_Stage_0Inputs */
/** @typedef {{}} Pet_Pup_Stage_1Inputs */
/** @typedef {{}} Pet_Pup_Stage_2Inputs */
/** @typedef {{}} Pet_Pup_Stage_3Inputs */
/** @typedef {{}} Pet_Pup_Stage_4Inputs */
/** @typedef {{}} Pet_Pup_Stage_5Inputs */
/** @typedef {{ name: NonNullable<unknown> }} Pet_SavedInputs */
/** @typedef {{}} Pet_ShuffleInputs */
/** @typedef {{}} Pet_Sprout_Stage_0Inputs */
/** @typedef {{}} Pet_Sprout_Stage_1Inputs */
/** @typedef {{}} Pet_Sprout_Stage_2Inputs */
/** @typedef {{}} Pet_Sprout_Stage_3Inputs */
/** @typedef {{}} Pet_Sprout_Stage_4Inputs */
/** @typedef {{}} Pet_Sprout_Stage_5Inputs */
/** @typedef {{}} Pet_TitleInputs */
/** @typedef {{}} Pets_TitleInputs */
/** @typedef {{}} Photo_AddInputs */
/** @typedef {{}} Photo_LabelInputs */
/** @typedef {{}} Photo_Read_ErrorInputs */
/** @typedef {{}} Photo_RemoveInputs */
/** @typedef {{}} Photo_ReplaceInputs */
/** @typedef {{ count: NonNullable<unknown> }} Plus_BonusInputs */
/** @typedef {{ coins: NonNullable<unknown> }} Project_BonusInputs */
/** @typedef {{}} Project_CreateInputs */
/** @typedef {{}} Project_DeleteInputs */
/** @typedef {{}} Project_Delete_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Project_Delete_TitleInputs */
/** @typedef {{}} Project_DoneInputs */
/** @typedef {{ name: NonNullable<unknown> }} Project_FinishedInputs */
/** @typedef {{}} Project_IntroInputs */
/** @typedef {{}} Project_NameInputs */
/** @typedef {{}} Project_NewInputs */
/** @typedef {{}} Project_New_SubInputs */
/** @typedef {{}} Project_PaceInputs */
/** @typedef {{}} Project_Pace_1Inputs */
/** @typedef {{}} Project_Pace_3Inputs */
/** @typedef {{}} Project_Pace_7Inputs */
/** @typedef {{}} Project_PlaceholderInputs */
/** @typedef {{ name: NonNullable<unknown>, done: NonNullable<unknown>, total: NonNullable<unknown> }} Project_ProgressInputs */
/** @typedef {{ done: NonNullable<unknown>, total: NonNullable<unknown> }} Project_Row_SubInputs */
/** @typedef {{ project: NonNullable<unknown>, step: NonNullable<unknown>, total: NonNullable<unknown> }} Project_Step_OfInputs */
/** @typedef {{}} Project_StepsInputs */
/** @typedef {{}} Project_Steps_HintInputs */
/** @typedef {{}} Push_BlockedInputs */
/** @typedef {{}} Push_Blocked_HereInputs */
/** @typedef {{ minutes: NonNullable<unknown> }} Push_Daily_Body_StartInputs */
/** @typedef {{ minutes: NonNullable<unknown>, streak: NonNullable<unknown> }} Push_Daily_Body_StreakInputs */
/** @typedef {{ chore: NonNullable<unknown> }} Push_Daily_TitleInputs */
/** @typedef {{ name: NonNullable<unknown> }} Push_High_Five_TitleInputs */
/** @typedef {{}} Push_Ios_FirstInputs */
/** @typedef {{}} Push_OnInputs */
/** @typedef {{ count: NonNullable<unknown> }} Push_On_DevicesInputs */
/** @typedef {{ mine: NonNullable<unknown>, total: NonNullable<unknown> }} Push_Recap_BodyInputs */
/** @typedef {{ mine: NonNullable<unknown> }} Push_Recap_Body_SoloInputs */
/** @typedef {{}} Push_Recap_TitleInputs */
/** @typedef {{}} Push_Streak_BodyInputs */
/** @typedef {{ count: NonNullable<unknown> }} Push_Streak_Body_FreezesInputs */
/** @typedef {{ streak: NonNullable<unknown> }} Push_Streak_TitleInputs */
/** @typedef {{ chore: NonNullable<unknown>, xp: NonNullable<unknown> }} Push_Team_BodyInputs */
/** @typedef {{ chore: NonNullable<unknown>, xp: NonNullable<unknown>, level: NonNullable<unknown> }} Push_Team_Body_LevelInputs */
/** @typedef {{ name: NonNullable<unknown> }} Push_Team_TitleInputs */
/** @typedef {{}} Push_Test_BodyInputs */
/** @typedef {{}} Push_Test_TitleInputs */
/** @typedef {{}} Push_Timer_Dishwasher_BodyInputs */
/** @typedef {{}} Push_Timer_Dishwasher_TitleInputs */
/** @typedef {{}} Push_Timer_Dryer_BodyInputs */
/** @typedef {{}} Push_Timer_Dryer_TitleInputs */
/** @typedef {{}} Push_Timer_Other_BodyInputs */
/** @typedef {{}} Push_Timer_Other_TitleInputs */
/** @typedef {{}} Push_Timer_Oven_BodyInputs */
/** @typedef {{}} Push_Timer_Oven_TitleInputs */
/** @typedef {{}} Push_Timer_Washer_BodyInputs */
/** @typedef {{}} Push_Timer_Washer_TitleInputs */
/** @typedef {{ name: NonNullable<unknown> }} Push_Trade_AcceptedInputs */
/** @typedef {{ chore: NonNullable<unknown> }} Push_Trade_Accepted_BodyInputs */
/** @typedef {{ give: NonNullable<unknown>, get: NonNullable<unknown> }} Push_Trade_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Push_Trade_DeclinedInputs */
/** @typedef {{ chore: NonNullable<unknown> }} Push_Trade_Declined_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Push_Trade_TitleInputs */
/** @typedef {{}} Push_UnsupportedInputs */
/** @typedef {{}} Push_Unsupported_HereInputs */
/** @typedef {{}} Q_BathroomsInputs */
/** @typedef {{}} Q_Home_TypeInputs */
/** @typedef {{}} Q_PetsInputs */
/** @typedef {{}} Q_SpacesInputs */
/** @typedef {{}} Q_ThingsInputs */
/** @typedef {{}} Q_ToiletInputs */
/** @typedef {{}} Rarity_CommonInputs */
/** @typedef {{}} Rarity_EpicInputs */
/** @typedef {{}} Rarity_LegendaryInputs */
/** @typedef {{}} Rarity_RareInputs */
/** @typedef {{}} RebalanceInputs */
/** @typedef {{}} Rebalance_Confirm_TitleInputs */
/** @typedef {{ people: NonNullable<unknown> }} Rebalance_SubInputs */
/** @typedef {{}} Rebalance_TitleInputs */
/** @typedef {{}} Recap_Household_ChoresInputs */
/** @typedef {{ total: NonNullable<unknown>, mine: NonNullable<unknown> }} Recap_RowInputs */
/** @typedef {{ mine: NonNullable<unknown> }} Recap_Row_SoloInputs */
/** @typedef {{}} Recap_SubtitleInputs */
/** @typedef {{}} Recap_TitleInputs */
/** @typedef {{ count: NonNullable<unknown>, name: NonNullable<unknown> }} Recap_TopInputs */
/** @typedef {{}} Recap_Your_ChoresInputs */
/** @typedef {{}} ReloadInputs */
/** @typedef {{}} Remind_Me_AtInputs */
/** @typedef {{}} Reminder_BodyInputs */
/** @typedef {{}} Reminder_CtaInputs */
/** @typedef {{}} Reminder_Cta_SubInputs */
/** @typedef {{ time: NonNullable<unknown> }} Reminder_SetInputs */
/** @typedef {{}} Reminder_TitleInputs */
/** @typedef {{}} RemindersInputs */
/** @typedef {{}} RemoveInputs */
/** @typedef {{}} RepeatsInputs */
/** @typedef {{}} Rescue_BonusInputs */
/** @typedef {{}} Rest_Day_BodyInputs */
/** @typedef {{}} Rest_Day_TitleInputs */
/** @typedef {{}} Review_ChoresInputs */
/** @typedef {{}} Rhythm_ChangeInputs */
/** @typedef {{ chore: NonNullable<unknown>, freq: NonNullable<unknown> }} Rhythm_ChangedInputs */
/** @typedef {{ chore: NonNullable<unknown> }} Rhythm_EarlyInputs */
/** @typedef {{}} Rhythm_KeepInputs */
/** @typedef {{}} Rhythm_LabelInputs */
/** @typedef {{ chore: NonNullable<unknown> }} Rhythm_LateInputs */
/** @typedef {{ new: NonNullable<unknown>, old: NonNullable<unknown> }} Rhythm_QuestionInputs */
/** @typedef {{ count: NonNullable<unknown>, chore: NonNullable<unknown> }} Rhythm_SkippedInputs */
/** @typedef {{}} RoomInputs */
/** @typedef {{}} Room_BathroomInputs */
/** @typedef {{}} Room_Bathroom_2Inputs */
/** @typedef {{}} Room_Bathroom_3Inputs */
/** @typedef {{}} Room_BedroomInputs */
/** @typedef {{ price: NonNullable<unknown>, pet: NonNullable<unknown> }} Room_Buy_BodyInputs */
/** @typedef {{}} Room_Dining_RoomInputs */
/** @typedef {{}} Room_GarageInputs */
/** @typedef {{}} Room_Guest_RoomInputs */
/** @typedef {{}} Room_HallwayInputs */
/** @typedef {{}} Room_IntroInputs */
/** @typedef {{}} Room_KitchenInputs */
/** @typedef {{}} Room_Laundry_RoomInputs */
/** @typedef {{}} Room_Living_RoomInputs */
/** @typedef {{}} Room_NameInputs */
/** @typedef {{}} Room_OfficeInputs */
/** @typedef {{}} Room_OutdoorsInputs */
/** @typedef {{}} Room_PetsInputs */
/** @typedef {{}} Room_PlacedInputs */
/** @typedef {{}} Room_PlaceholderInputs */
/** @typedef {{ count: NonNullable<unknown> }} Room_Row_SubInputs */
/** @typedef {{}} Room_Tap_To_PlaceInputs */
/** @typedef {{ pet: NonNullable<unknown> }} Room_TitleInputs */
/** @typedef {{}} Room_ToiletInputs */
/** @typedef {{}} Room_Whole_HouseInputs */
/** @typedef {{}} SaveInputs */
/** @typedef {{}} Save_DateInputs */
/** @typedef {{}} SavedInputs */
/** @typedef {{}} Schedule_HintInputs */
/** @typedef {{}} Schedule_SavedInputs */
/** @typedef {{}} SeasonalInputs */
/** @typedef {{}} Seasonal_SubInputs */
/** @typedef {{}} SectionsInputs */
/** @typedef {{ count: NonNullable<unknown> }} See_AllInputs */
/** @typedef {{}} Select_All_That_ApplyInputs */
/** @typedef {{}} SettingsInputs */
/** @typedef {{ people: NonNullable<unknown>, active: NonNullable<unknown>, perDay: NonNullable<unknown>, more: NonNullable<unknown> }} Setup_BodyInputs */
/** @typedef {{ active: NonNullable<unknown>, perDay: NonNullable<unknown>, more: NonNullable<unknown> }} Setup_Body_SoloInputs */
/** @typedef {{}} Setup_TitleInputs */
/** @typedef {{}} Share_InviteInputs */
/** @typedef {{ pet: NonNullable<unknown> }} Shop_IntroInputs */
/** @typedef {{}} Shop_OutfitsInputs */
/** @typedef {{}} Shop_OwnedInputs */
/** @typedef {{}} Shop_Row_SubInputs */
/** @typedef {{}} Shop_TitleInputs */
/** @typedef {{ count: NonNullable<unknown> }} Shop_To_GoInputs */
/** @typedef {{}} Shop_WearingInputs */
/** @typedef {{}} Show_EarnedInputs */
/** @typedef {{ count: NonNullable<unknown> }} Show_InactiveInputs */
/** @typedef {{}} Show_MoreInputs */
/** @typedef {{}} Sign_InInputs */
/** @typedef {{}} Sign_Out_DeviceInputs */
/** @typedef {{}} Sign_Out_HereInputs */
/** @typedef {{}} Signed_InInputs */
/** @typedef {{ name: NonNullable<unknown> }} Slip_BodyInputs */
/** @typedef {{}} Slip_OkInputs */
/** @typedef {{ pet: NonNullable<unknown> }} Slip_SignedInputs */
/** @typedef {{}} Slip_TitleInputs */
/** @typedef {{}} SomeoneInputs */
/** @typedef {{}} Start_BreakInputs */
/** @typedef {{}} Stat_ChoresInputs */
/** @typedef {{}} Stat_FreezesInputs */
/** @typedef {{ best: NonNullable<unknown> }} Stat_StreakInputs */
/** @typedef {{}} Step_AddInputs */
/** @typedef {{ name: NonNullable<unknown> }} Step_DeleteInputs */
/** @typedef {{ name: NonNullable<unknown> }} Step_Done_ByInputs */
/** @typedef {{ n: NonNullable<unknown> }} Step_NInputs */
/** @typedef {{ step: NonNullable<unknown>, total: NonNullable<unknown> }} Step_OfInputs */
/** @typedef {{}} Step_PlaceholderInputs */
/** @typedef {{ n: NonNullable<unknown> }} Step_RemoveInputs */
/** @typedef {{ minutes: NonNullable<unknown> }} Step_Up_NextInputs */
/** @typedef {{}} Sticker_BirdInputs */
/** @typedef {{}} Sticker_BucketInputs */
/** @typedef {{}} Sticker_CatInputs */
/** @typedef {{}} Sticker_CrownInputs */
/** @typedef {{}} Sticker_FishInputs */
/** @typedef {{}} Sticker_FlowerInputs */
/** @typedef {{ rarity: NonNullable<unknown> }} Sticker_LabelInputs */
/** @typedef {{}} Sticker_LampInputs */
/** @typedef {{}} Sticker_LemonInputs */
/** @typedef {{}} Sticker_PlantInputs */
/** @typedef {{}} Sticker_RainbowInputs */
/** @typedef {{}} Sticker_RobotInputs */
/** @typedef {{}} Sticker_ShirtInputs */
/** @typedef {{}} Sticker_SoapInputs */
/** @typedef {{}} Sticker_SparklesInputs */
/** @typedef {{}} Sticker_SpongeInputs */
/** @typedef {{}} Sticker_SprayInputs */
/** @typedef {{}} Sticker_TeaInputs */
/** @typedef {{}} Sticker_WandInputs */
/** @typedef {{}} Sticker_WasherInputs */
/** @typedef {{}} StickersInputs */
/** @typedef {{ owned: NonNullable<unknown>, total: NonNullable<unknown> }} Stickers_FoundInputs */
/** @typedef {{}} Stickers_HintInputs */
/** @typedef {{ count: NonNullable<unknown> }} Streak_DaysInputs */
/** @typedef {{}} SuppliesInputs */
/** @typedef {{}} Supplies_AddInputs */
/** @typedef {{ name: NonNullable<unknown> }} Supplies_Added_ByInputs */
/** @typedef {{}} Supplies_BoughtInputs */
/** @typedef {{}} Supplies_ClearInputs */
/** @typedef {{}} Supplies_EmptyInputs */
/** @typedef {{}} Supplies_PlaceholderInputs */
/** @typedef {{ count: NonNullable<unknown> }} Supplies_SubInputs */
/** @typedef {{}} Supplies_Sub_EmptyInputs */
/** @typedef {{}} SwapInputs */
/** @typedef {{}} SwappedInputs */
/** @typedef {{}} Switched_Off_BodyInputs */
/** @typedef {{}} Switched_Off_EmptyInputs */
/** @typedef {{}} Switched_Off_TitleInputs */
/** @typedef {{}} Tab_ChoresInputs */
/** @typedef {{}} Tab_HouseInputs */
/** @typedef {{}} Tab_ProfileInputs */
/** @typedef {{}} Tab_TodayInputs */
/** @typedef {{}} Take_BonusInputs */
/** @typedef {{}} Take_BreakInputs */
/** @typedef {{}} Take_Break_SubInputs */
/** @typedef {{}} Takes_AboutInputs */
/** @typedef {{}} Tap_To_ContinueInputs */
/** @typedef {{}} TestInputs */
/** @typedef {{}} Test_NoneInputs */
/** @typedef {{}} Test_SentInputs */
/** @typedef {{}} This_DeviceInputs */
/** @typedef {{}} TimerInputs */
/** @typedef {{}} Timer_ClearInputs */
/** @typedef {{ time: NonNullable<unknown> }} Timer_Done_AtInputs */
/** @typedef {{ time: NonNullable<unknown> }} Timer_Finished_AtInputs */
/** @typedef {{ minutes: NonNullable<unknown> }} Timer_GoInputs */
/** @typedef {{}} Timer_How_LongInputs */
/** @typedef {{}} Timer_IntroInputs */
/** @typedef {{}} Timer_Intro_No_PushInputs */
/** @typedef {{}} Timer_Kind_DishwasherInputs */
/** @typedef {{}} Timer_Kind_DryerInputs */
/** @typedef {{}} Timer_Kind_OtherInputs */
/** @typedef {{}} Timer_Kind_OvenInputs */
/** @typedef {{}} Timer_Kind_WasherInputs */
/** @typedef {{}} Timer_MachineInputs */
/** @typedef {{}} Timer_MinutesInputs */
/** @typedef {{}} Timer_NewInputs */
/** @typedef {{}} Timer_New_SubInputs */
/** @typedef {{}} Timer_PauseInputs */
/** @typedef {{}} Timer_RestartInputs */
/** @typedef {{}} Timer_ResumeInputs */
/** @typedef {{}} Timer_StartInputs */
/** @typedef {{ time: NonNullable<unknown> }} Timer_Start_AtInputs */
/** @typedef {{}} Timer_StopInputs */
/** @typedef {{}} Timers_TitleInputs */
/** @typedef {{}} Times_UpInputs */
/** @typedef {{}} TodayInputs */
/** @typedef {{}} Toilet_In_BathroomInputs */
/** @typedef {{}} Toilet_SeparateInputs */
/** @typedef {{}} TradeInputs */
/** @typedef {{}} Trade_AcceptInputs */
/** @typedef {{ name: NonNullable<unknown> }} Trade_AskInputs */
/** @typedef {{}} Trade_DeclineInputs */
/** @typedef {{}} Trade_DoneInputs */
/** @typedef {{ name: NonNullable<unknown> }} Trade_IncomingInputs */
/** @typedef {{ name: NonNullable<unknown> }} Trade_SentInputs */
/** @typedef {{}} Trade_TheirsInputs */
/** @typedef {{ name: NonNullable<unknown> }} Trade_TitleInputs */
/** @typedef {{ name: NonNullable<unknown> }} Trade_WaitingInputs */
/** @typedef {{}} Trade_You_GetInputs */
/** @typedef {{}} Trade_You_GiveInputs */
/** @typedef {{}} Trade_YoursInputs */
/** @typedef {{}} Treat_AddInputs */
/** @typedef {{}} Treat_Name_LabelInputs */
/** @typedef {{}} Treat_Name_PlaceholderInputs */
/** @typedef {{}} Treat_Price_LabelInputs */
/** @typedef {{}} Treat_RedeemInputs */
/** @typedef {{}} Treats_EarnedInputs */
/** @typedef {{}} Treats_EmptyInputs */
/** @typedef {{}} Treats_IntroInputs */
/** @typedef {{}} Treats_Row_SubInputs */
/** @typedef {{}} Treats_TitleInputs */
/** @typedef {{}} Try_AgainInputs */
/** @typedef {{}} Turn_OnInputs */
/** @typedef {{}} Turn_On_RemindersInputs */
/** @typedef {{ tz: NonNullable<unknown> }} Tz_NoteInputs */
/** @typedef {{ tz: NonNullable<unknown> }} Tz_SwitchInputs */
/** @typedef {{}} Verdict_BalancedInputs */
/** @typedef {{}} Verdict_TightInputs */
/** @typedef {{}} Verdict_Too_MuchInputs */
/** @typedef {{}} WeatherInputs */
/** @typedef {{}} Weather_IntroInputs */
/** @typedef {{}} Weather_NoneInputs */
/** @typedef {{}} Weather_RemoveInputs */
/** @typedef {{}} Weather_SearchInputs */
/** @typedef {{}} Weather_Sub_OffInputs */
/** @typedef {{ place: NonNullable<unknown> }} Weather_Sub_OnInputs */
/** @typedef {{}} Weather_TitleInputs */
/** @typedef {{}} Welcome_CreateInputs */
/** @typedef {{}} Welcome_JoinInputs */
/** @typedef {{}} Welcome_LinkInputs */
/** @typedef {{}} Who_Does_ItInputs */
/** @typedef {{}} Who_Does_It_HintInputs */
/** @typedef {{ xp: NonNullable<unknown>, next: NonNullable<unknown>, name: NonNullable<unknown> }} Xp_Until_GrowsInputs */
/** @typedef {{}} YayInputs */
/** @typedef {{ count: NonNullable<unknown> }} Year_DaysInputs */
/** @typedef {{}} Year_EmptyInputs */
/** @typedef {{}} Year_EndInputs */
/** @typedef {{}} Year_FavInputs */
/** @typedef {{}} Year_High_FivesInputs */
/** @typedef {{ year: NonNullable<unknown> }} Year_IntroInputs */
/** @typedef {{}} Year_Intro_SubInputs */
/** @typedef {{ month: NonNullable<unknown> }} Year_MonthInputs */
/** @typedef {{ pet: NonNullable<unknown>, stage: NonNullable<unknown> }} Year_PetInputs */
/** @typedef {{}} Year_RoomInputs */
/** @typedef {{ year: NonNullable<unknown> }} Year_RowInputs */
/** @typedef {{}} Year_Row_SubInputs */
/** @typedef {{}} Year_RunInputs */
/** @typedef {{}} Year_Run_SubInputs */
/** @typedef {{}} Year_ShareInputs */
/** @typedef {{ count: NonNullable<unknown> }} Year_TimesInputs */
/** @typedef {{}} Year_TotalInputs */
/** @typedef {{}} YesterdayInputs */
/** @typedef {{}} YouInputs */
/** @typedef {{}} You_SuffixInputs */
/** @typedef {{}} Your_ColourInputs */
/** @typedef {{}} Your_CompanionInputs */
/** @typedef {{}} Your_DevicesInputs */
/** @typedef {{}} Your_HomeInputs */
/** @typedef {{}} Your_Home_SubInputs */
/** @typedef {{}} Your_Home_UnsetInputs */
/** @typedef {{}} Your_NameInputs */
/** @typedef {{}} Your_WeekInputs */
import * as registry from "../registry.js"


export const active = /** @type {(inputs: ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actief`)
};

export const active_sub = /** @type {(inputs: Active_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uitgeschakelde klusjes worden nooit gekozen`)
};

export const activity = /** @type {(inputs: ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activiteit`)
};

export const activity_empty = /** @type {(inputs: Activity_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afgeronde klusjes verschijnen hier.`)
};

export const activity_empty_person = /** @type {(inputs: Activity_Empty_PersonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} heeft nog geen klusjes gedaan.`)
};

export const add_chore = /** @type {(inputs: Add_ChoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klusje toevoegen`)
};

export const add_home_first = /** @type {(inputs: Add_Home_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eerst op beginscherm zetten`)
};

export const ago_days = /** @type {(inputs: Ago_DaysInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("nl", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} dag geleden`);
	return /** @type {LocalizedString} */ (`${i?.count} dagen geleden`)
	
};

export const ago_hours = /** @type {(inputs: Ago_HoursInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} uur geleden`)
};

export const ago_minutes = /** @type {(inputs: Ago_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} min geleden`)
};

export const ago_now = /** @type {(inputs: Ago_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`zojuist`)
};

export const anyone = /** @type {(inputs: AnyoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iedereen`)
};

export const app_tagline = /** @type {(inputs: App_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eén klein klusje per dag houdt het hele huis op orde.`)
};

export const back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terug`)
};

export const badge_bonus10_desc = /** @type {(inputs: Badge_Bonus10_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rond 10 bonusklusjes af`)
};

export const badge_bonus10_name = /** @type {(inputs: Badge_Bonus10_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uitblinker`)
};

export const badge_bonus_desc = /** @type {(inputs: Badge_Bonus_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rond een bonusklusje af`)
};

export const badge_bonus_name = /** @type {(inputs: Badge_Bonus_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stapje Extra`)
};

export const badge_done10_desc = /** @type {(inputs: Badge_Done10_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rond 10 klusjes af`)
};

export const badge_done10_name = /** @type {(inputs: Badge_Done10_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De Slag Te Pakken`)
};

export const badge_done250_desc = /** @type {(inputs: Badge_Done250_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rond 250 klusjes af`)
};

export const badge_done250_name = /** @type {(inputs: Badge_Done250_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoeder van het Kasteel`)
};

export const badge_done50_desc = /** @type {(inputs: Badge_Done50_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rond 50 klusjes af`)
};

export const badge_done50_name = /** @type {(inputs: Badge_Done50_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewoonte Gevormd`)
};

export const badge_early_desc = /** @type {(inputs: Badge_Early_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rond een klusje af voor 8 uur 's ochtends`)
};

export const badge_early_name = /** @type {(inputs: Badge_Early_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vroege Vogel`)
};

export const badge_first_desc = /** @type {(inputs: Badge_First_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rond je eerste klusje af`)
};

export const badge_first_name = /** @type {(inputs: Badge_First_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frisse Start`)
};

export const badge_freeze_desc = /** @type {(inputs: Badge_Freeze_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laat een bevriezer je reeks redden`)
};

export const badge_freeze_name = /** @type {(inputs: Badge_Freeze_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gered door het IJs`)
};

export const badge_level10_desc = /** @type {(inputs: Badge_Level10_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereik level 10`)
};

export const badge_level10_name = /** @type {(inputs: Badge_Level10_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superster`)
};

export const badge_level5_desc = /** @type {(inputs: Badge_Level5_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereik level 5`)
};

export const badge_level5_name = /** @type {(inputs: Badge_Level5_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rijzende Ster`)
};

export const badge_night_desc = /** @type {(inputs: Badge_Night_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rond een klusje af na 10 uur 's avonds`)
};

export const badge_night_name = /** @type {(inputs: Badge_Night_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachtuil`)
};

export const badge_rare_desc = /** @type {(inputs: Badge_Rare_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rond een klusje af dat hooguit twee keer per jaar voorkomt`)
};

export const badge_rare_name = /** @type {(inputs: Badge_Rare_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeldzame Vondst`)
};

export const badge_rescue_desc = /** @type {(inputs: Badge_Rescue_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doe een klusje dat een hele periode te laat was`)
};

export const badge_rescue_name = /** @type {(inputs: Badge_Rescue_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reddingsactie`)
};

export const badge_room_desc = /** @type {(inputs: Badge_Room_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zorg dat alle klusjes in een ruimte (3 of meer) bij zijn`)
};

export const badge_room_name = /** @type {(inputs: Badge_Room_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamerheld`)
};

export const badge_stickers10_desc = /** @type {(inputs: Badge_Stickers10_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verzamel 10 verschillende stickers`)
};

export const badge_stickers10_name = /** @type {(inputs: Badge_Stickers10_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verzamelaar`)
};

export const badge_streak100_desc = /** @type {(inputs: Badge_Streak100_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haal 100 dagen op rij`)
};

export const badge_streak100_name = /** @type {(inputs: Badge_Streak100_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centurion`)
};

export const badge_streak30_desc = /** @type {(inputs: Badge_Streak30_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haal 30 dagen op rij`)
};

export const badge_streak30_name = /** @type {(inputs: Badge_Streak30_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magische Maand`)
};

export const badge_streak3_desc = /** @type {(inputs: Badge_Streak3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haal 3 dagen op rij`)
};

export const badge_streak3_name = /** @type {(inputs: Badge_Streak3_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Op Gang`)
};

export const badge_streak7_desc = /** @type {(inputs: Badge_Streak7_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haal 7 dagen op rij`)
};

export const badge_streak7_name = /** @type {(inputs: Badge_Streak7_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weekstrijder`)
};

export const badge_team_desc = /** @type {(inputs: Badge_Team_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iedereen in huis rondde op dezelfde dag zijn klusje af`)
};

export const badge_team_name = /** @type {(inputs: Badge_Team_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Droomteam`)
};

export const badges = /** @type {(inputs: BadgesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Badges`)
};

export const big_job = /** @type {(inputs: Big_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grote klus`)
};

export const big_jobs = /** @type {(inputs: Big_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grote klussen`)
};

export const bonus = /** @type {(inputs: BonusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bonus`)
};

export const break_body = /** @type {(inputs: Break_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tot dan geen klusjes en geen herinneringen. Je reeks staat op pauze, niet op nul.`)
};

export const break_days = /** @type {(inputs: Break_DaysInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("nl", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} dag`);
	return /** @type {LocalizedString} */ (`${i?.count} dagen`)
	
};

export const break_end = /** @type {(inputs: Break_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pauze stoppen`)
};

export const break_ends = /** @type {(inputs: Break_EndsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Eindigt op ${i?.date}`)
};

export const break_how_long = /** @type {(inputs: Break_How_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe lang ben je weg?`)
};

export const break_reassure = /** @type {(inputs: Break_ReassureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je reeks staat op pauze en blijft bewaard. Geen klusjes of herinneringen, en de lijsten van je huisgenoten veranderen niet.`)
};

export const break_sick = /** @type {(inputs: Break_SickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ziek`)
};

export const break_sick_title = /** @type {(inputs: Break_Sick_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beterschap`)
};

export const break_title = /** @type {(inputs: Break_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geniet van je pauze`)
};

export const break_today = /** @type {(inputs: Break_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alleen vandaag`)
};

export const break_two_weeks = /** @type {(inputs: Break_Two_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 weken`)
};

export const break_until = /** @type {(inputs: Break_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tot ${i?.date}`)
};

export const break_vacation = /** @type {(inputs: Break_VacationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vakantie`)
};

export const break_week = /** @type {(inputs: Break_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 week`)
};

export const break_weekend = /** @type {(inputs: Break_WeekendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tot zondag`)
};

export const buy = /** @type {(inputs: BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopen`)
};

export const buy_confirm_body = /** @type {(inputs: Buy_Confirm_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} munten. ${i?.pet} trekt het meteen aan.`)
};

export const buy_confirm_title = /** @type {(inputs: Buy_Confirm_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.item} kopen?`)
};

export const calendar_break = /** @type {(inputs: Calendar_BreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pauze van klusjes`)
};

export const calendar_copied = /** @type {(inputs: Calendar_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link gekopieerd`)
};

export const calendar_copy = /** @type {(inputs: Calendar_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link kopiëren`)
};

export const calendar_create = /** @type {(inputs: Calendar_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maak mijn agendalink`)
};

export const calendar_done = /** @type {(inputs: Calendar_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gedaan: ${i?.chore}`)
};

export const calendar_google = /** @type {(inputs: Calendar_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Agenda: Andere agenda's, Via URL, en plak de link.`)
};

export const calendar_guests = /** @type {(inputs: Calendar_GuestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er komt bezoek`)
};

export const calendar_intro = /** @type {(inputs: Calendar_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eén keer abonneren en je agenda toont het klusje van vandaag, jouw eigen klusjes, pauzes en bezoek. Het werkt zichzelf elke paar uur bij.`)
};

export const calendar_linked = /** @type {(inputs: Calendar_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je agendalink is actief. Voor de veiligheid zie je hem maar één keer: vraag een nieuwe aan als je hem opnieuw nodig hebt.`)
};

export const calendar_minutes = /** @type {(inputs: Calendar_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ongeveer ${i?.minutes} minuten`)
};

export const calendar_name = /** @type {(inputs: Calendar_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Klusjes ${i?.household}`)
};

export const calendar_open = /** @type {(inputs: Calendar_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Openen in Agenda`)
};

export const calendar_private = /** @type {(inputs: Calendar_PrivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iedereen met deze link ziet je klusjes, dus houd hem voor jezelf.`)
};

export const calendar_reset = /** @type {(inputs: Calendar_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieuwe link maken`)
};

export const calendar_row_on = /** @type {(inputs: Calendar_Row_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je agenda is gekoppeld`)
};

export const calendar_row_sub = /** @type {(inputs: Calendar_Row_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zie het klusje van vandaag tussen je afspraken`)
};

export const calendar_stop = /** @type {(inputs: Calendar_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agenda stoppen`)
};

export const calendar_title = /** @type {(inputs: Calendar_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klusjes in je agenda`)
};

export const calendar_yours = /** @type {(inputs: Calendar_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jouw klusje`)
};

export const cancel = /** @type {(inputs: CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuleren`)
};

export const chore_added = /** @type {(inputs: Chore_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klusje toegevoegd`)
};

export const chore_aquarium = /** @type {(inputs: Chore_AquariumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deel van het aquariumwater verversen en de ruit schoonmaken`)
};

export const chore_balcony = /** @type {(inputs: Chore_BalconyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het balkon / terras vegen`)
};

export const chore_bath_mats = /** @type {(inputs: Chore_Bath_MatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Badmatten wassen en handdoeken verschonen`)
};

export const chore_bathroom_floor = /** @type {(inputs: Chore_Bathroom_FloorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De badkamervloer dweilen`)
};

export const chore_bathroom_sink = /** @type {(inputs: Chore_Bathroom_SinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De wastafel en spiegel schoonmaken`)
};

export const chore_bathtub = /** @type {(inputs: Chore_BathtubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het bad schrobben`)
};

export const chore_bin = /** @type {(inputs: Chore_BinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De prullenbak uitwassen`)
};

export const chore_bird_cage = /** @type {(inputs: Chore_Bird_CageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De vogelkooi schoonmaken`)
};

export const chore_cabinets = /** @type {(inputs: Chore_CabinetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kastdeurtjes en handgrepen afnemen`)
};

export const chore_cage = /** @type {(inputs: Chore_CageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het hok uitmesten`)
};

export const chore_curtains = /** @type {(inputs: Chore_CurtainsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De gordijnen wassen`)
};

export const chore_descale_kettle = /** @type {(inputs: Chore_Descale_KettleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De waterkoker / koffiemachine ontkalken`)
};

export const chore_desk = /** @type {(inputs: Chore_DeskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bureau opruimen en afnemen`)
};

export const chore_dining_table = /** @type {(inputs: Chore_Dining_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eettafel en stoelen afnemen`)
};

export const chore_dishwasher_filter = /** @type {(inputs: Chore_Dishwasher_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het vaatwasserfilter schoonmaken`)
};

export const chore_doors = /** @type {(inputs: Chore_DoorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle deuren en kozijnen afnemen`)
};

export const chore_drawer = /** @type {(inputs: Chore_DrawerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eén la opruimen`)
};

export const chore_dryer_lint = /** @type {(inputs: Chore_Dryer_LintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pluizenfilter en condensor van de droger schoonmaken`)
};

export const chore_dust = /** @type {(inputs: Chore_DustInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oppervlakken en planken afstoffen`)
};

export const chore_fans = /** @type {(inputs: Chore_FansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plafondventilatoren en lampen afstoffen`)
};

export const chore_freezer = /** @type {(inputs: Chore_FreezerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De vriezer ontdooien`)
};

export const chore_fridge_clearout = /** @type {(inputs: Chore_Fridge_ClearoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De koelkast opruimen (oud eten weg, vlekken afnemen)`)
};

export const chore_fridge_deep = /** @type {(inputs: Chore_Fridge_DeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De koelkastplanken grondig schoonmaken`)
};

export const chore_garage = /** @type {(inputs: Chore_GarageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Garage vegen en opruimen`)
};

export const chore_garden_furniture = /** @type {(inputs: Chore_Garden_FurnitureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuinmeubels schoonmaken`)
};

export const chore_grout = /** @type {(inputs: Chore_GroutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De voegen schrobben`)
};

export const chore_guest_room = /** @type {(inputs: Chore_Guest_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logeerkamer afstoffen en luchten`)
};

export const chore_gutters = /** @type {(inputs: Chore_GuttersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De dakgoten schoonmaken`)
};

export const chore_hallway = /** @type {(inputs: Chore_HallwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gang vegen en de deurmat uitkloppen`)
};

export const chore_hood_filter = /** @type {(inputs: Chore_Hood_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het afzuigkapfilter ontvetten`)
};

export const chore_kitchen_sink = /** @type {(inputs: Chore_Kitchen_SinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De gootsteen en afvoer schrobben`)
};

export const chore_laundry_room = /** @type {(inputs: Chore_Laundry_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Washok opruimen en afnemen`)
};

export const chore_litter_box = /** @type {(inputs: Chore_Litter_BoxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De kattenbak helemaal verversen`)
};

export const chore_mattress = /** @type {(inputs: Chore_MattressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het matras draaien / keren`)
};

export const chore_microwave = /** @type {(inputs: Chore_MicrowaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De magnetron schoonmaken`)
};

export const chore_mop_kitchen = /** @type {(inputs: Chore_Mop_KitchenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De keukenvloer dweilen`)
};

export const chore_n_of = /** @type {(inputs: Chore_N_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} van ${i?.total}`)
};

export const chore_name_label = /** @type {(inputs: Chore_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naam van het klusje`)
};

export const chore_nightstand = /** @type {(inputs: Chore_NightstandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachtkastje en ladekast opruimen`)
};

export const chore_oven = /** @type {(inputs: Chore_OvenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De oven schoonmaken`)
};

export const chore_pantry = /** @type {(inputs: Chore_PantryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De voorraadkast opruimen en houdbaarheidsdata checken`)
};

export const chore_pet_bed = /** @type {(inputs: Chore_Pet_BedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mand en dekentjes wassen`)
};

export const chore_pet_bowls = /** @type {(inputs: Chore_Pet_BowlsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voer- en drinkbakjes afwassen`)
};

export const chore_pet_hair = /** @type {(inputs: Chore_Pet_HairInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haren van de bank zuigen`)
};

export const chore_pet_toys = /** @type {(inputs: Chore_Pet_ToysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speeltjes en riem wassen`)
};

export const chore_pillows = /** @type {(inputs: Chore_PillowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kussens en dekbed wassen`)
};

export const chore_placeholder = /** @type {(inputs: Chore_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat moet er gebeuren?`)
};

export const chore_plant_leaves = /** @type {(inputs: Chore_Plant_LeavesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De bladeren van de planten afstoffen`)
};

export const chore_plants = /** @type {(inputs: Chore_PlantsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De planten water geven`)
};

export const chore_radiators = /** @type {(inputs: Chore_RadiatorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De radiatoren ontluchten`)
};

export const chore_rugs = /** @type {(inputs: Chore_RugsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kleden en deurmatten uitkloppen`)
};

export const chore_screens = /** @type {(inputs: Chore_ScreensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schermen en toetsenbord afstoffen`)
};

export const chore_sheets = /** @type {(inputs: Chore_SheetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het bed verschonen`)
};

export const chore_shower = /** @type {(inputs: Chore_ShowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De douche / het bad schrobben`)
};

export const chore_shower_curtain = /** @type {(inputs: Chore_Shower_CurtainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het douchegordijn wassen / de douchewand schoonmaken`)
};

export const chore_showerhead = /** @type {(inputs: Chore_ShowerheadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De douchekop en kranen ontkalken`)
};

export const chore_skirting = /** @type {(inputs: Chore_SkirtingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De plinten afstoffen`)
};

export const chore_smoke_alarms = /** @type {(inputs: Chore_Smoke_AlarmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De rookmelders testen`)
};

export const chore_sofa = /** @type {(inputs: Chore_SofaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De bank stofzuigen en de kussens opschudden`)
};

export const chore_stairs = /** @type {(inputs: Chore_StairsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De trap stofzuigen`)
};

export const chore_stovetop = /** @type {(inputs: Chore_StovetopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De kookplaat ontvetten`)
};

export const chore_switches = /** @type {(inputs: Chore_SwitchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lichtknoppen, afstandsbedieningen en deurklinken afnemen`)
};

export const chore_toilet = /** @type {(inputs: Chore_ToiletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het toilet schoonmaken`)
};

export const chore_toilet_basin = /** @type {(inputs: Chore_Toilet_BasinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fonteintje en toiletvloer afnemen`)
};

export const chore_under_bed = /** @type {(inputs: Chore_Under_BedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onder het bed stofzuigen`)
};

export const chore_vacuum_filter = /** @type {(inputs: Chore_Vacuum_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het stofzuigerfilter schoonmaken`)
};

export const chore_vacuum_living = /** @type {(inputs: Chore_Vacuum_LivingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De woonkamer stofzuigen`)
};

export const chore_wardrobe = /** @type {(inputs: Chore_WardrobeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De kledingkast uitzoeken: weg met wat je niet draagt`)
};

export const chore_washing_machine = /** @type {(inputs: Chore_Washing_MachineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De wasmachine een reinigingsprogramma laten draaien en de rubberen rand afnemen`)
};

export const chore_weeding = /** @type {(inputs: Chore_WeedingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onkruid wieden`)
};

export const chore_windows_inside = /** @type {(inputs: Chore_Windows_InsideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De ramen lappen (binnenkant)`)
};

export const chore_windows_outside = /** @type {(inputs: Chore_Windows_OutsideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De ramen aan de buitenkant lappen`)
};

export const chores_count = /** @type {(inputs: Chores_CountInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("nl", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} klusje`);
	return /** @type {LocalizedString} */ (`${i?.count} klusjes`)
	
};

export const chores_on = /** @type {(inputs: Chores_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} klusjes staan aan`)
};

export const cleanliness = /** @type {(inputs: CleanlinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Netheid`)
};

export const close = /** @type {(inputs: CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sluiten`)
};

export const coins_label = /** @type {(inputs: Coins_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Munten`)
};

export const coins_n = /** @type {(inputs: Coins_NInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("nl", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} munt`);
	return /** @type {LocalizedString} */ (`${i?.count} munten`)
	
};

export const colour = /** @type {(inputs: ColourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kleur`)
};

export const companion = /** @type {(inputs: CompanionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maatje`)
};

export const confirm_delete_chore = /** @type {(inputs: Confirm_Delete_ChoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit klusje voor iedereen in het huishouden verwijderen?`)
};

export const confirm_leave = /** @type {(inputs: Confirm_LeaveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`“${i?.household}” verlaten? Je voortgang wordt verwijderd. Ben je het laatste lid, dan wordt het huishouden ook verwijderd.`)
};

export const confirm_sign_out = /** @type {(inputs: Confirm_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je hebt een uitnodigings- of apparaatcode nodig om op dit apparaat opnieuw in te loggen.`)
};

export const _continue = /** @type {(inputs: _ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doorgaan`)
};

export const copy_code = /** @type {(inputs: Copy_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code kopiëren`)
};

export const crash_body = /** @type {(inputs: Crash_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorry daarvoor. Herladen lost het meestal op; je klusjes zijn veilig.`)
};

export const crash_title = /** @type {(inputs: Crash_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er ging iets stuk`)
};

export const create_household = /** @type {(inputs: Create_HouseholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huishouden aanmaken`)
};

export const daily_time = /** @type {(inputs: Daily_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tijd per dag`)
};

export const daily_time_sub = /** @type {(inputs: Daily_Time_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langere klusjes komen alleen als er niets anders aan de beurt is`)
};

export const days_overdue = /** @type {(inputs: Days_OverdueInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("nl", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} dag te laat`);
	return /** @type {LocalizedString} */ (`${i?.count} dagen te laat`)
	
};

export const _delete = /** @type {(inputs: _DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwijderen`)
};

export const delete_chore = /** @type {(inputs: Delete_ChoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klusje verwijderen`)
};

export const device_app = /** @type {(inputs: Device_AppInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.os} · App`)
};

export const device_code = /** @type {(inputs: Device_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apparaatcode`)
};

export const device_generic = /** @type {(inputs: Device_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apparaat`)
};

export const device_name = /** @type {(inputs: Device_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.browser} op ${i?.os}`)
};

export const done = /** @type {(inputs: DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gedaan`)
};

export const done_button = /** @type {(inputs: Done_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klaar`)
};

export const done_for_today = /** @type {(inputs: Done_For_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klaar voor vandaag`)
};

export const dry_day = /** @type {(inputs: Dry_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Droge dag: goed weer hiervoor`)
};

export const due_in_days = /** @type {(inputs: Due_In_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Over ${i?.count} dagen`)
};

export const due_today = /** @type {(inputs: Due_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vandaag aan de beurt`)
};

export const due_tomorrow = /** @type {(inputs: Due_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Morgen aan de beurt`)
};

export const duration_h = /** @type {(inputs: Duration_HInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hours} u`)
};

export const duration_h_m = /** @type {(inputs: Duration_H_MInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hours} u ${i?.minutes} min`)
};

export const easier_one = /** @type {(inputs: Easier_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iets makkelijkers`)
};

export const edit_chore = /** @type {(inputs: Edit_ChoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klusje bewerken`)
};

export const effort = /** @type {(inputs: EffortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moeite`)
};

export const effort_1 = /** @type {(inputs: Effort_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Makkelijk`)
};

export const effort_2 = /** @type {(inputs: Effort_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gemiddeld`)
};

export const effort_3 = /** @type {(inputs: Effort_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zwaar`)
};

export const err_already_done = /** @type {(inputs: Err_Already_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dat is al gedaan.`)
};

export const err_assignment_not_found = /** @type {(inputs: Err_Assignment_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dat klusje staat niet op je lijst.`)
};

export const err_avatar = /** @type {(inputs: Err_AvatarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kies een van de avatarkleuren.`)
};

export const err_bonus_needs_daily = /** @type {(inputs: Err_Bonus_Needs_DailyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rond eerst het klusje van vandaag af, pak dan een bonus.`)
};

export const err_bonus_none = /** @type {(inputs: Err_Bonus_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vandaag is er niets meer te doen. Het huis glimt.`)
};

export const err_bonus_pending = /** @type {(inputs: Err_Bonus_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er staat al een bonusklusje voor je klaar.`)
};

export const err_chore_name = /** @type {(inputs: Err_Chore_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vul de naam van het klusje in.`)
};

export const err_chore_not_found = /** @type {(inputs: Err_Chore_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klusje niet gevonden.`)
};

export const err_code = /** @type {(inputs: Err_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vul de code in.`)
};

export const err_forbidden = /** @type {(inputs: Err_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dat verzoek mocht niet. Herlaad de pagina en probeer het opnieuw.`)
};

export const err_freezes_full = /** @type {(inputs: Err_Freezes_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je hebt al zoveel bevriezers als je kunt bewaren.`)
};

export const err_freq = /** @type {(inputs: Err_FreqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kies tussen 1 en 730 dagen.`)
};

export const err_generic = /** @type {(inputs: Err_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er ging iets mis.`)
};

export const err_guests_date = /** @type {(inputs: Err_Guests_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kies een dag in de komende twee maanden.`)
};

export const err_high_five_self = /** @type {(inputs: Err_High_Five_SelfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jezelf een high-five geven gaat niet. (Leuk geprobeerd.)`)
};

export const err_household_name = /** @type {(inputs: Err_Household_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vul een naam voor het huishouden in.`)
};

export const err_household_too_small = /** @type {(inputs: Err_Household_Too_SmallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Er wonen al ${i?.count} mensen in dit huishouden.`)
};

export const err_invalid = /** @type {(inputs: Err_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controleer wat je hebt ingevuld.`)
};

export const err_invite_code = /** @type {(inputs: Err_Invite_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vul de uitnodigingscode in.`)
};

export const err_invite_not_found = /** @type {(inputs: Err_Invite_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die uitnodigingscode hoort bij geen enkel huishouden.`)
};

export const err_item_owned = /** @type {(inputs: Err_Item_OwnedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die heb je al.`)
};

export const err_link_invalid = /** @type {(inputs: Err_Link_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die code is ongeldig of verlopen.`)
};

export const err_member_not_found = /** @type {(inputs: Err_Member_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lid niet gevonden.`)
};

export const err_no_connection = /** @type {(inputs: Err_No_ConnectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je bent offline. Controleer je verbinding en probeer het opnieuw.`)
};

export const err_no_swap_option = /** @type {(inputs: Err_No_Swap_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er is geen ander klusje om naar te wisselen.`)
};

export const err_not_enough_coins = /** @type {(inputs: Err_Not_Enough_CoinsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog niet genoeg munten.`)
};

export const err_not_found = /** @type {(inputs: Err_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niet gevonden.`)
};

export const err_nothing_to_swap = /** @type {(inputs: Err_Nothing_To_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er valt nu niets te wisselen.`)
};

export const err_offline = /** @type {(inputs: Err_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kan de server niet bereiken. Ben je offline?`)
};

export const err_owner = /** @type {(inputs: Err_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die persoon hoort niet bij dit huishouden.`)
};

export const err_pause_past = /** @type {(inputs: Err_Pause_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een pauze kan niet in het verleden eindigen.`)
};

export const err_pause_too_long = /** @type {(inputs: Err_Pause_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een pauze duurt maximaal een jaar.`)
};

export const err_people_max = /** @type {(inputs: Err_People_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximaal 8 personen.`)
};

export const err_people_min = /** @type {(inputs: Err_People_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er woont minstens één persoon.`)
};

export const err_pet_name = /** @type {(inputs: Err_Pet_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vul een naam voor het huisdier in.`)
};

export const err_photo_invalid = /** @type {(inputs: Err_Photo_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dat lijkt geen foto. Probeer een JPEG of PNG.`)
};

export const err_photo_too_big = /** @type {(inputs: Err_Photo_Too_BigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die foto is te groot.`)
};

export const err_places_unavailable = /** @type {(inputs: Err_Places_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De weerdienst reageert niet. Probeer het later nog eens.`)
};

export const err_project_last_step = /** @type {(inputs: Err_Project_Last_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een grote klus heeft minstens één stap nodig. Verwijder anders de hele klus.`)
};

export const err_project_name = /** @type {(inputs: Err_Project_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geef de klus een naam.`)
};

export const err_project_steps = /** @type {(inputs: Err_Project_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voeg minstens één stap toe (hooguit 20).`)
};

export const err_push_subscription = /** @type {(inputs: Err_Push_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ongeldig pushabonnement.`)
};

export const err_rate_limited = /** @type {(inputs: Err_Rate_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Te veel pogingen. Wacht een minuutje en probeer het opnieuw.`)
};

export const err_room = /** @type {(inputs: Err_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vul de ruimte in.`)
};

export const err_schedule_empty = /** @type {(inputs: Err_Schedule_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kies minstens één dag met een klusje.`)
};

export const err_server = /** @type {(inputs: Err_ServerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er ging bij ons iets mis.`)
};

export const err_sign_in = /** @type {(inputs: Err_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log in.`)
};

export const err_sign_in_again = /** @type {(inputs: Err_Sign_In_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log opnieuw in.`)
};

export const err_step_name = /** @type {(inputs: Err_Step_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is de stap?`)
};

export const err_supplies_full = /** @type {(inputs: Err_Supplies_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De lijst is vol. Vink eerst wat af.`)
};

export const err_supply_name = /** @type {(inputs: Err_Supply_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat heb je nodig?`)
};

export const err_swap_used = /** @type {(inputs: Err_Swap_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je hebt vandaag al gewisseld.`)
};

export const err_time_format = /** @type {(inputs: Err_Time_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De herinneringstijd moet eruitzien als 18:30.`)
};

export const err_timeout = /** @type {(inputs: Err_TimeoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De server reageerde te traag. Probeer het opnieuw.`)
};

export const err_timer_minutes = /** @type {(inputs: Err_Timer_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kies tussen 1 en 360 minuten.`)
};

export const err_timers_full = /** @type {(inputs: Err_Timers_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dat zijn veel apparaten tegelijk. Haal eerst een klaar exemplaar weg.`)
};

export const err_too_large = /** @type {(inputs: Err_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verzoek te groot.`)
};

export const err_too_long = /** @type {(inputs: Err_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dat is te lang.`)
};

export const err_trade_gone = /** @type {(inputs: Err_Trade_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die ruil staat niet meer open.`)
};

export const err_trade_nothing = /** @type {(inputs: Err_Trade_NothingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jullie hebben allebei vandaag een klusje nodig om te ruilen.`)
};

export const err_trade_owned = /** @type {(inputs: Err_Trade_OwnedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een van deze klusjes is van iemand, dus die kan niet geruild worden.`)
};

export const err_treat_name = /** @type {(inputs: Err_Treat_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is de traktatie?`)
};

export const err_treat_price = /** @type {(inputs: Err_Treat_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kies een prijs tussen 10 en 100.000 munten.`)
};

export const err_treats_full = /** @type {(inputs: Err_Treats_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dat zijn veel traktaties! Verwijder er eerst een.`)
};

export const err_tz = /** @type {(inputs: Err_TzInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onbekende tijdzone.`)
};

export const err_your_name = /** @type {(inputs: Err_Your_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vul je naam in.`)
};

export const every_how_many_days = /** @type {(inputs: Every_How_Many_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om de hoeveel dagen`)
};

export const everyone = /** @type {(inputs: EveryoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iedereen`)
};

export const expired = /** @type {(inputs: ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verlopen. Sluit dit en maak een nieuwe code.`)
};

export const expires_in = /** @type {(inputs: Expires_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Verloopt over ${i?.time}`)
};

export const fair_share = /** @type {(inputs: Fair_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eerlijk verdeeld`)
};

export const fair_share_empty = /** @type {(inputs: Fair_Share_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog te weinig gedaan om te vergelijken.`)
};

export const fair_share_hint = /** @type {(inputs: Fair_Share_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Moeite over de laatste ${i?.days} dagen (minuten keer hoe zwaar). Wie meer doet, krijgt even lichtere klusjes.`)
};

export const first_badge_hint = /** @type {(inputs: First_Badge_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je eerste klusje levert je eerste badge op.`)
};

export const found_sticker = /** @type {(inputs: Found_StickerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`vond ${i?.sticker}`)
};

export const freeze_bought = /** @type {(inputs: Freeze_BoughtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bevriezer staat klaar`)
};

export const freeze_confirm_body = /** @type {(inputs: Freeze_Confirm_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} munten. Mis je een klusdag, dan blijft je reeks gewoon staan.`)
};

export const freeze_confirm_title = /** @type {(inputs: Freeze_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bevriezer kopen?`)
};

export const freeze_covered = /** @type {(inputs: Freeze_CoveredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een bevriezer heeft de gemiste dag opgevangen`)
};

export const freeze_earned = /** @type {(inputs: Freeze_EarnedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bevriezer verdiend`)
};

export const freeze_earned_sub = /** @type {(inputs: Freeze_Earned_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vangt automatisch één gemiste dag op`)
};

export const freeze_full = /** @type {(inputs: Freeze_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vol`)
};

export const freeze_item = /** @type {(inputs: Freeze_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bevriezer`)
};

export const freeze_item_sub = /** @type {(inputs: Freeze_Item_SubInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vangt een gemiste klusdag op · je hebt er ${i?.count} van ${i?.max}`)
};

export const freezes_count = /** @type {(inputs: Freezes_CountInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("nl", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} bevriezer`);
	return /** @type {LocalizedString} */ (`${i?.count} bevriezers`)
	
};

export const freq_2months = /** @type {(inputs: Freq_2monthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elke 2 maanden`)
};

export const freq_2weeks = /** @type {(inputs: Freq_2weeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elke 2 weken`)
};

export const freq_3months = /** @type {(inputs: Freq_3monthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elke 3 maanden`)
};

export const freq_custom = /** @type {(inputs: Freq_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anders…`)
};

export const freq_daily = /** @type {(inputs: Freq_DailyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dagelijks`)
};

export const freq_every_days = /** @type {(inputs: Freq_Every_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Elke ${i?.count} dagen`)
};

export const freq_every_weeks = /** @type {(inputs: Freq_Every_WeeksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Elke ${i?.count} weken`)
};

export const freq_monthly = /** @type {(inputs: Freq_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maandelijks`)
};

export const freq_twice_year = /** @type {(inputs: Freq_Twice_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twee keer per jaar`)
};

export const freq_weekly = /** @type {(inputs: Freq_WeeklyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wekelijks`)
};

export const freq_yearly = /** @type {(inputs: Freq_YearlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jaarlijks`)
};

export const fully_grown = /** @type {(inputs: Fully_GrownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volgroeid`)
};

export const furniture_aquarium = /** @type {(inputs: Furniture_AquariumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aquarium`)
};

export const furniture_bookcase = /** @type {(inputs: Furniture_BookcaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boekenkast`)
};

export const furniture_clock = /** @type {(inputs: Furniture_ClockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klok`)
};

export const furniture_cushion = /** @type {(inputs: Furniture_CushionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kussen`)
};

export const furniture_disco_ball = /** @type {(inputs: Furniture_Disco_BallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discobal`)
};

export const furniture_dots = /** @type {(inputs: Furniture_DotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stippenbehang`)
};

export const furniture_fairy_lights = /** @type {(inputs: Furniture_Fairy_LightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lichtslinger`)
};

export const furniture_floor_lamp = /** @type {(inputs: Furniture_Floor_LampInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staande lamp`)
};

export const furniture_painting = /** @type {(inputs: Furniture_PaintingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schilderij`)
};

export const furniture_permission = /** @type {(inputs: Furniture_PermissionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pet} heeft een ${i?.item}! Zie dit als toestemming om je eigen kamer ook eens te verwennen.`)
};

export const furniture_plant = /** @type {(inputs: Furniture_PlantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plant`)
};

export const furniture_rug = /** @type {(inputs: Furniture_RugInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kleed`)
};

export const furniture_shelf = /** @type {(inputs: Furniture_ShelfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plank`)
};

export const furniture_stripes = /** @type {(inputs: Furniture_StripesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Streepjesbehang`)
};

export const furniture_window = /** @type {(inputs: Furniture_WindowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raam`)
};

export const guests_banner = /** @type {(inputs: Guests_BannerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bezoek ${i?.date}: de kamers die ze zien komen eerst.`)
};

export const guests_clear = /** @type {(inputs: Guests_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toch geen bezoek`)
};

export const guests_intro = /** @type {(inputs: Guests_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In de dagen ervoor komen de klusjes die bezoek ziet eerst: toilet, woonkamer, gang, keuken.`)
};

export const guests_on = /** @type {(inputs: Guests_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bezoek ${i?.date}`)
};

export const guests_pick = /** @type {(inputs: Guests_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Of kies een datum`)
};

export const guests_row = /** @type {(inputs: Guests_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komt er bezoek?`)
};

export const guests_row_sub = /** @type {(inputs: Guests_Row_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De kamers die mensen zien komen eerst`)
};

export const guests_title = /** @type {(inputs: Guests_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wanneer komt er bezoek?`)
};

export const guests_tomorrow = /** @type {(inputs: Guests_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Morgen`)
};

export const hide_inactive = /** @type {(inputs: Hide_InactiveInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("nl", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} uitgeschakeld klusje verbergen`);
	return /** @type {LocalizedString} */ (`${i?.count} uitgeschakelde klusjes verbergen`)
	
};

export const high_five = /** @type {(inputs: High_FiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`High-five`)
};

export const high_fived = /** @type {(inputs: High_FivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`High-five gegeven`)
};

export const history = /** @type {(inputs: HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschiedenis`)
};

export const history_empty = /** @type {(inputs: History_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog niet gedaan in de app.`)
};

export const home_intro = /** @type {(inputs: Home_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zo krijg je alleen klusjes die kloppen. Je kunt dit later aanpassen.`)
};

export const home_pet_bird = /** @type {(inputs: Home_Pet_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vogel`)
};

export const home_pet_cat = /** @type {(inputs: Home_Pet_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kat`)
};

export const home_pet_dog = /** @type {(inputs: Home_Pet_DogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hond`)
};

export const home_pet_fish = /** @type {(inputs: Home_Pet_FishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vissen`)
};

export const home_pet_small_pet = /** @type {(inputs: Home_Pet_Small_PetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konijn of knaagdier`)
};

export const home_saved = /** @type {(inputs: Home_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klussenlijst aangepast aan je huis`)
};

export const home_space_balcony = /** @type {(inputs: Home_Space_BalconyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balkon`)
};

export const home_space_dining = /** @type {(inputs: Home_Space_DiningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eethoek`)
};

export const home_space_garage = /** @type {(inputs: Home_Space_GarageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Garage`)
};

export const home_space_garden = /** @type {(inputs: Home_Space_GardenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuin`)
};

export const home_space_guest_room = /** @type {(inputs: Home_Space_Guest_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logeerkamer`)
};

export const home_space_laundry = /** @type {(inputs: Home_Space_LaundryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Washok`)
};

export const home_space_office = /** @type {(inputs: Home_Space_OfficeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Werkkamer`)
};

export const home_space_stairs = /** @type {(inputs: Home_Space_StairsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trap`)
};

export const home_thing_bathtub = /** @type {(inputs: Home_Thing_BathtubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bad`)
};

export const home_thing_dishwasher = /** @type {(inputs: Home_Thing_DishwasherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaatwasser`)
};

export const home_thing_dryer = /** @type {(inputs: Home_Thing_DryerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Droger`)
};

export const home_thing_plants = /** @type {(inputs: Home_Thing_PlantsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamerplanten`)
};

export const home_title = /** @type {(inputs: Home_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vertel iets over je huis`)
};

export const home_type_apartment = /** @type {(inputs: Home_Type_ApartmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appartement`)
};

export const home_type_house = /** @type {(inputs: Home_Type_HouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huis`)
};

export const household = /** @type {(inputs: HouseholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huishouden`)
};

export const household_name = /** @type {(inputs: Household_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naam van het huishouden`)
};

export const household_name_placeholder = /** @type {(inputs: Household_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ons huis`)
};

export const in_season = /** @type {(inputs: In_SeasonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seizoen: ${i?.months}`)
};

export const install_body = /** @type {(inputs: Install_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het werkt het best als app: dagelijkse herinneringen, schermvullend en met één tik op je beginscherm.`)
};

export const install_button = /** @type {(inputs: Install_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App installeren`)
};

export const install_done_body = /** @type {(inputs: Install_Done_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open CleanReminder vanaf je beginscherm of in je apps om te beginnen.`)
};

export const install_done_title = /** @type {(inputs: Install_Done_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geïnstalleerd`)
};

export const install_invite_note = /** @type {(inputs: Install_Invite_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je uitnodigingscode. Die heb je nodig in de app:`)
};

export const install_ios_1 = /** @type {(inputs: Install_Ios_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tik op Deel in de balk van Safari`)
};

export const install_ios_2 = /** @type {(inputs: Install_Ios_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kies “Zet op beginscherm”`)
};

export const install_open = /** @type {(inputs: Install_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open CleanReminder vanaf je beginscherm`)
};

export const install_other_1 = /** @type {(inputs: Install_Other_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open het menu van je browser`)
};

export const install_other_2 = /** @type {(inputs: Install_Other_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kies “App installeren” of “Toevoegen aan startscherm”`)
};

export const install_skip = /** @type {(inputs: Install_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toch in de browser gebruiken`)
};

export const install_title = /** @type {(inputs: Install_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Installeer CleanReminder`)
};

export const invite_code = /** @type {(inputs: Invite_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uitnodigingscode`)
};

export const invite_code_toast = /** @type {(inputs: Invite_Code_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Uitnodigingscode: ${i?.code}`)
};

export const invite_copied = /** @type {(inputs: Invite_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uitnodigingslink gekopieerd`)
};

export const invite_text = /** @type {(inputs: Invite_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Doe mee met “${i?.household}” op CleanReminder. Uitnodigingscode: ${i?.code}`)
};

export const invite_warning = /** @type {(inputs: Invite_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iedereen met de uitnodigingscode kan meedoen, dus deel hem alleen met je huisgenoten.`)
};

export const ios_home_screen = /** @type {(inputs: Ios_Home_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zet de app op iPhone eerst op je beginscherm (Deel, dan Zet op beginscherm) en open hem vanaf daar.`)
};

export const item_beanie = /** @type {(inputs: Item_BeanieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muts`)
};

export const item_bikini = /** @type {(inputs: Item_BikiniInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bikini`)
};

export const item_bow = /** @type {(inputs: Item_BowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strik`)
};

export const item_broom = /** @type {(inputs: Item_BroomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mini-bezem`)
};

export const item_flower = /** @type {(inputs: Item_FlowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloem`)
};

export const item_glasses = /** @type {(inputs: Item_GlassesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bril`)
};

export const item_party_hat = /** @type {(inputs: Item_Party_HatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feesthoedje`)
};

export const item_permission = /** @type {(inputs: Item_PermissionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pet} heeft de ${i?.item}! Zie dit als toestemming om er zelf ook een te kopen.`)
};

export const item_scarf = /** @type {(inputs: Item_ScarfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sjaal`)
};

export const item_sunglasses = /** @type {(inputs: Item_SunglassesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zonnebril`)
};

export const item_sunhat = /** @type {(inputs: Item_SunhatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zonnehoed`)
};

export const join = /** @type {(inputs: JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meedoen`)
};

export const join_household = /** @type {(inputs: Join_HouseholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meedoen met een huishouden`)
};

export const keep_list = /** @type {(inputs: Keep_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lijst zo laten`)
};

export const language = /** @type {(inputs: LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taal`)
};

export const language_auto = /** @type {(inputs: Language_AutoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zoals op je apparaat (${i?.language})`)
};

export const last_7_days = /** @type {(inputs: Last_7_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afgelopen 7 dagen`)
};

export const last_active = /** @type {(inputs: Last_ActiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Laatst actief ${i?.when}`)
};

export const last_done = /** @type {(inputs: Last_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laatst gedaan`)
};

export const last_done_by = /** @type {(inputs: Last_Done_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.when} door ${i?.name}`)
};

export const last_done_days = /** @type {(inputs: Last_Done_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} dagen geleden gedaan`)
};

export const last_done_today = /** @type {(inputs: Last_Done_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vandaag gedaan`)
};

export const last_done_yesterday = /** @type {(inputs: Last_Done_YesterdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gisteren gedaan`)
};

export const ld_few_days = /** @type {(inputs: Ld_Few_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een paar dagen geleden`)
};

export const ld_few_months = /** @type {(inputs: Ld_Few_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een paar maanden geleden`)
};

export const ld_month = /** @type {(inputs: Ld_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een maand geleden`)
};

export const ld_today = /** @type {(inputs: Ld_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vandaag`)
};

export const ld_two_weeks = /** @type {(inputs: Ld_Two_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twee weken geleden`)
};

export const ld_week = /** @type {(inputs: Ld_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ongeveer een week geleden`)
};

export const ld_year = /** @type {(inputs: Ld_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meer dan een jaar geleden`)
};

export const ld_yesterday = /** @type {(inputs: Ld_YesterdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gisteren`)
};

export const leave_household = /** @type {(inputs: Leave_HouseholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huishouden verlaten`)
};

export const level_n = /** @type {(inputs: Level_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Level ${i?.level}`)
};

export const level_title_0 = /** @type {(inputs: Level_Title_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stofbeginner`)
};

export const level_title_1 = /** @type {(inputs: Level_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sponsschildknaap`)
};

export const level_title_10 = /** @type {(inputs: Level_Title_10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legende van het Pluizenfilter`)
};

export const level_title_2 = /** @type {(inputs: Level_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kruimeljager`)
};

export const level_title_3 = /** @type {(inputs: Level_Title_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dweilridder`)
};

export const level_title_4 = /** @type {(inputs: Level_Title_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezembaron`)
};

export const level_title_5 = /** @type {(inputs: Level_Title_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schrobtovenaar`)
};

export const level_title_6 = /** @type {(inputs: Level_Title_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hertogin van het Afstoffen`)
};

export const level_title_7 = /** @type {(inputs: Level_Title_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opruimtitaan`)
};

export const level_title_8 = /** @type {(inputs: Level_Title_8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vuilverslinder`)
};

export const level_title_9 = /** @type {(inputs: Level_Title_9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glanswijze`)
};

export const level_up_sub = /** @type {(inputs: Level_Up_SubInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Je bent nu ${i?.title}`)
};

export const link_device = /** @type {(inputs: Link_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apparaat koppelen`)
};

export const link_device_sub = /** @type {(inputs: Link_Device_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebruik je account op een andere telefoon of computer`)
};

export const link_intro = /** @type {(inputs: Link_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open op een apparaat waar je al bent ingelogd Instellingen en tik op “Apparaat koppelen”. Vul de code in die daar staat.`)
};

export const link_sheet_body = /** @type {(inputs: Link_Sheet_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open CleanReminder op het andere apparaat en kies “Inloggen met een apparaatcode”.`)
};

export const link_title = /** @type {(inputs: Link_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inloggen`)
};

export const load_error_title = /** @type {(inputs: Load_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je huis kon niet worden geladen`)
};

export const loading = /** @type {(inputs: LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laden…`)
};

export const mark_done = /** @type {(inputs: Mark_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afvinken`)
};

export const mark_x_done = /** @type {(inputs: Mark_X_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} afvinken`)
};

export const minutes_short = /** @type {(inputs: Minutes_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min`)
};

export const mood_grumpy = /** @type {(inputs: Mood_GrumpyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chagrijnig`)
};

export const mood_happy = /** @type {(inputs: Mood_HappyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blij`)
};

export const mood_meh = /** @type {(inputs: Mood_MehInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mwah`)
};

export const mood_sad = /** @type {(inputs: Mood_SadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verstopt`)
};

export const mood_thriving = /** @type {(inputs: Mood_ThrivingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stralend`)
};

export const name = /** @type {(inputs: NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naam`)
};

export const never_mind = /** @type {(inputs: Never_MindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laat maar`)
};

export const new_chore = /** @type {(inputs: New_ChoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieuw klusje`)
};

export const new_code = /** @type {(inputs: New_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieuwe code`)
};

export const new_household = /** @type {(inputs: New_HouseholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieuw huishouden`)
};

export const new_room = /** @type {(inputs: New_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieuwe ruimte…`)
};

export const next_badges = /** @type {(inputs: Next_BadgesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volgende badges`)
};

export const no_chores_available = /** @type {(inputs: No_Chores_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen klusjes om uit te kiezen. Zet er een paar aan bij Klusjes.`)
};

export const no_streak = /** @type {(inputs: No_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen reeks`)
};

export const not_done_yet = /** @type {(inputs: Not_Done_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog niet gedaan`)
};

export const not_now = /** @type {(inputs: Not_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niet nu`)
};

export const not_sure = /** @type {(inputs: Not_SureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weet ik niet`)
};

export const notes = /** @type {(inputs: NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notities`)
};

export const notes_hint = /** @type {(inputs: Notes_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staat op de kaart van het klusje, bijvoorbeeld welk schoonmaakmiddel je gebruikt.`)
};

export const notes_placeholder = /** @type {(inputs: Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebruik de blauwe spray, geen bleek`)
};

export const nothing_picked = /** @type {(inputs: Nothing_PickedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog niets gekozen`)
};

export const notif_daily = /** @type {(inputs: Notif_DailyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dagelijks klusje`)
};

export const notif_daily_sub = /** @type {(inputs: Notif_Daily_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Op je herinneringstijd`)
};

export const notif_recap = /** @type {(inputs: Notif_RecapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weekoverzicht`)
};

export const notif_recap_sub = /** @type {(inputs: Notif_Recap_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zondag om 19:00: hoe de week ging`)
};

export const notif_streak = /** @type {(inputs: Notif_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reeksherinnering`)
};

export const notif_streak_sub = /** @type {(inputs: Notif_Streak_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om 20:30 als het klusje van vandaag nog niet gedaan is`)
};

export const notif_team = /** @type {(inputs: Notif_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activiteit in huis`)
};

export const notif_team_sub = /** @type {(inputs: Notif_Team_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als iemand een klusje afrondt`)
};

export const notifications = /** @type {(inputs: NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meldingen`)
};

export const off = /** @type {(inputs: OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uit`)
};

export const off_this_device = /** @type {(inputs: Off_This_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uit op dit apparaat`)
};

export const offline_banner = /** @type {(inputs: Offline_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je bent offline`)
};

export const on_a_break = /** @type {(inputs: On_A_BreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pauze`)
};

export const overdue_count = /** @type {(inputs: Overdue_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} te laat`)
};

export const people = /** @type {(inputs: PeopleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personen`)
};

export const people_count = /** @type {(inputs: People_CountInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("nl", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} persoon`);
	return /** @type {LocalizedString} */ (`${i?.count} personen`)
	
};

export const people_hint = /** @type {(inputs: People_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iedereen doet één klusje per dag, dus dit bepaalt hoe groot je klussenlijst begint. Je kunt het later aanpassen.`)
};

export const people_question = /** @type {(inputs: People_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Met hoeveel mensen woon je hier?`)
};

export const people_sub = /** @type {(inputs: People_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bepaalt hoeveel klusjes er aanstaan`)
};

export const per_day_needed = /** @type {(inputs: Per_Day_NeededInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.perDay} per dag nodig`)
};

export const pet_bunny_stage_0 = /** @type {(inputs: Pet_Bunny_Stage_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stofje`)
};

export const pet_bunny_stage_1 = /** @type {(inputs: Pet_Bunny_Stage_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Babykonijntje`)
};

export const pet_bunny_stage_2 = /** @type {(inputs: Pet_Bunny_Stage_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pluizenbol`)
};

export const pet_bunny_stage_3 = /** @type {(inputs: Pet_Bunny_Stage_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volwassen Konijn`)
};

export const pet_bunny_stage_4 = /** @type {(inputs: Pet_Bunny_Stage_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Majestueuze Pluis`)
};

export const pet_bunny_stage_5 = /** @type {(inputs: Pet_Bunny_Stage_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legendarische Pluis`)
};

export const pet_cat_stage_0 = /** @type {(inputs: Pet_Cat_Stage_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kitten`)
};

export const pet_cat_stage_1 = /** @type {(inputs: Pet_Cat_Stage_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klein Katje`)
};

export const pet_cat_stage_2 = /** @type {(inputs: Pet_Cat_Stage_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieuwsgierige Kat`)
};

export const pet_cat_stage_3 = /** @type {(inputs: Pet_Cat_Stage_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huiskat`)
};

export const pet_cat_stage_4 = /** @type {(inputs: Pet_Cat_Stage_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Majestueuze Muizenvanger`)
};

export const pet_cat_stage_5 = /** @type {(inputs: Pet_Cat_Stage_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legendarische Leeuw`)
};

export const pet_chick_stage_0 = /** @type {(inputs: Pet_Chick_Stage_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eitje`)
};

export const pet_chick_stage_1 = /** @type {(inputs: Pet_Chick_Stage_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuikentje`)
};

export const pet_chick_stage_2 = /** @type {(inputs: Pet_Chick_Stage_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donzig Kuiken`)
};

export const pet_chick_stage_3 = /** @type {(inputs: Pet_Chick_Stage_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jonge Vogel`)
};

export const pet_chick_stage_4 = /** @type {(inputs: Pet_Chick_Stage_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trotse Vogel`)
};

export const pet_chick_stage_5 = /** @type {(inputs: Pet_Chick_Stage_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legendarische Feniks`)
};

export const pet_fox_stage_0 = /** @type {(inputs: Pet_Fox_Stage_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klein Vosje`)
};

export const pet_fox_stage_1 = /** @type {(inputs: Pet_Fox_Stage_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vossenwelp`)
};

export const pet_fox_stage_2 = /** @type {(inputs: Pet_Fox_Stage_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieuwsgierige Vos`)
};

export const pet_fox_stage_3 = /** @type {(inputs: Pet_Fox_Stage_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slimme Vos`)
};

export const pet_fox_stage_4 = /** @type {(inputs: Pet_Fox_Stage_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Majestueuze Vos`)
};

export const pet_fox_stage_5 = /** @type {(inputs: Pet_Fox_Stage_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legendarische Negenstaart`)
};

export const pet_grew_body = /** @type {(inputs: Pet_Grew_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} is nu een ${i?.stage}. Allemaal dankzij jouw klusjes.`)
};

export const pet_grew_title = /** @type {(inputs: Pet_Grew_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} is gegroeid!`)
};

export const pet_intro = /** @type {(inputs: Pet_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het groeit met elk klusje dat je doet, en aan het humeur zie je hoe het huis erbij staat.`)
};

export const pet_kind_bunny = /** @type {(inputs: Pet_Kind_BunnyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stofkonijn`)
};

export const pet_kind_cat = /** @type {(inputs: Pet_Kind_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kat`)
};

export const pet_kind_chick = /** @type {(inputs: Pet_Kind_ChickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuiken`)
};

export const pet_kind_fox = /** @type {(inputs: Pet_Kind_FoxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vos`)
};

export const pet_kind_pup = /** @type {(inputs: Pet_Kind_PupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pup`)
};

export const pet_kind_sprout = /** @type {(inputs: Pet_Kind_SproutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spruitje`)
};

export const pet_name_ideas = /** @type {(inputs: Pet_Name_IdeasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pluis,Koekje,Pip,Mochi,Noedel,Kiezel,Wafel,Boontje,Hagel,Nugget,Poffertje,Knoopje,Tosti,Klaver`)
};

export const pet_name_label = /** @type {(inputs: Pet_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naam van het huisdier`)
};

export const pet_owner = /** @type {(inputs: Pet_OwnerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Van ${i?.name}`)
};

export const pet_pup_stage_0 = /** @type {(inputs: Pet_Pup_Stage_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasgeboren Pup`)
};

export const pet_pup_stage_1 = /** @type {(inputs: Pet_Pup_Stage_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puppy`)
};

export const pet_pup_stage_2 = /** @type {(inputs: Pet_Pup_Stage_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Pup`)
};

export const pet_pup_stage_3 = /** @type {(inputs: Pet_Pup_Stage_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beste Vriend`)
};

export const pet_pup_stage_4 = /** @type {(inputs: Pet_Pup_Stage_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Topper`)
};

export const pet_pup_stage_5 = /** @type {(inputs: Pet_Pup_Stage_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legendarische Hond`)
};

export const pet_saved = /** @type {(inputs: Pet_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zeg hallo tegen ${i?.name}`)
};

export const pet_shuffle = /** @type {(inputs: Pet_ShuffleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stel een naam voor`)
};

export const pet_sprout_stage_0 = /** @type {(inputs: Pet_Sprout_Stage_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaadje`)
};

export const pet_sprout_stage_1 = /** @type {(inputs: Pet_Sprout_Stage_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiemplantje`)
};

export const pet_sprout_stage_2 = /** @type {(inputs: Pet_Sprout_Stage_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stekje`)
};

export const pet_sprout_stage_3 = /** @type {(inputs: Pet_Sprout_Stage_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bladerige Vriend`)
};

export const pet_sprout_stage_4 = /** @type {(inputs: Pet_Sprout_Stage_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloeiende Schoonheid`)
};

export const pet_sprout_stage_5 = /** @type {(inputs: Pet_Sprout_Stage_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legendarische Boom`)
};

export const pet_title = /** @type {(inputs: Pet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kies een maatje`)
};

export const pets_title = /** @type {(inputs: Pets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maatjes`)
};

export const photo_add = /** @type {(inputs: Photo_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto toevoegen`)
};

export const photo_label = /** @type {(inputs: Photo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profielfoto`)
};

export const photo_read_error = /** @type {(inputs: Photo_Read_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die afbeelding kon niet gelezen worden. Probeer een andere foto.`)
};

export const photo_remove = /** @type {(inputs: Photo_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwijderen`)
};

export const photo_replace = /** @type {(inputs: Photo_ReplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vervangen`)
};

export const plus_bonus = /** @type {(inputs: Plus_BonusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+ ${i?.count} bonus`)
};

export const project_bonus = /** @type {(inputs: Project_BonusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.coins} bonusmunten voor een afgeronde grote klus`)
};

export const project_create = /** @type {(inputs: Project_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klus starten`)
};

export const project_delete = /** @type {(inputs: Project_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grote klus verwijderen`)
};

export const project_delete_body = /** @type {(inputs: Project_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De stappen gaan ook weg. Wat al gedaan is, blijft in de geschiedenis staan.`)
};

export const project_delete_title = /** @type {(inputs: Project_Delete_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} verwijderen?`)
};

export const project_done = /** @type {(inputs: Project_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Helemaal klaar`)
};

export const project_finished = /** @type {(inputs: Project_FinishedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: helemaal klaar!`)
};

export const project_intro = /** @type {(inputs: Project_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verdeel hem in hapklare stappen. Ze komen één voor één langs tussen je gewone klusjes.`)
};

export const project_name = /** @type {(inputs: Project_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is de klus?`)
};

export const project_new = /** @type {(inputs: Project_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieuwe grote klus`)
};

export const project_new_sub = /** @type {(inputs: Project_New_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De garage uitmesten, stukje bij beetje`)
};

export const project_pace = /** @type {(inputs: Project_PaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe snel`)
};

export const project_pace_1 = /** @type {(inputs: Project_Pace_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elke dag een stap`)
};

export const project_pace_3 = /** @type {(inputs: Project_Pace_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om de paar dagen`)
};

export const project_pace_7 = /** @type {(inputs: Project_Pace_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elke week een stap`)
};

export const project_placeholder = /** @type {(inputs: Project_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De garage uitmesten`)
};

export const project_progress = /** @type {(inputs: Project_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: ${i?.done} van ${i?.total} stappen gedaan`)
};

export const project_row_sub = /** @type {(inputs: Project_Row_SubInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.done} van ${i?.total} stappen gedaan`)
};

export const project_step_of = /** @type {(inputs: Project_Step_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.project} · stap ${i?.step} van ${i?.total}`)
};

export const project_steps = /** @type {(inputs: Project_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stappen, op volgorde`)
};

export const project_steps_hint = /** @type {(inputs: Project_Steps_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zo'n 15 minuten per stap werkt het best.`)
};

export const push_blocked = /** @type {(inputs: Push_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meldingen zijn geblokkeerd in je browserinstellingen.`)
};

export const push_blocked_here = /** @type {(inputs: Push_Blocked_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geblokkeerd. Sta meldingen voor CleanReminder toe in de instellingen van je telefoon.`)
};

export const push_daily_body_start = /** @type {(inputs: Push_Daily_Body_StartInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ongeveer ${i?.minutes} minuten. Een mooie dag om een reeks te beginnen.`)
};

export const push_daily_body_streak = /** @type {(inputs: Push_Daily_Body_StreakInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ongeveer ${i?.minutes} minuten. Hou je reeks van ${i?.streak} dagen vast.`)
};

export const push_daily_title = /** @type {(inputs: Push_Daily_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vandaag: ${i?.chore}`)
};

export const push_high_five_title = /** @type {(inputs: Push_High_Five_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} geeft je een high-five`)
};

export const push_ios_first = /** @type {(inputs: Push_Ios_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zet de app op iPhone eerst op je beginscherm.`)
};

export const push_on = /** @type {(inputs: Push_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herinneringen staan aan`)
};

export const push_on_devices = /** @type {(inputs: Push_On_DevicesInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("nl", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Aan op ${i?.count} apparaat`);
	return /** @type {LocalizedString} */ (`Aan op ${i?.count} apparaten`)
	
};

export const push_recap_body = /** @type {(inputs: Push_Recap_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Jij deed ${i?.mine} klusjes, het hele huishouden ${i?.total}. Open de app voor het hele overzicht.`)
};

export const push_recap_body_solo = /** @type {(inputs: Push_Recap_Body_SoloInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Je deed deze week ${i?.mine} klusjes. Open de app voor het hele overzicht.`)
};

export const push_recap_title = /** @type {(inputs: Push_Recap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jullie week in huis`)
};

export const push_streak_body = /** @type {(inputs: Push_Streak_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tien minuutjes en hij blijft leven.`)
};

export const push_streak_body_freezes = /** @type {(inputs: Push_Streak_Body_FreezesInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("nl", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Je hebt nog ${i?.count} bevriezer, maar met tien minuten zit je veilig.`);
	return /** @type {LocalizedString} */ (`Je hebt nog ${i?.count} bevriezers, maar met tien minuten zit je veilig.`)
	
};

export const push_streak_title = /** @type {(inputs: Push_Streak_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Je reeks van ${i?.streak} dagen stopt vannacht`)
};

export const push_team_body = /** @type {(inputs: Push_Team_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.chore}, +${i?.xp} XP`)
};

export const push_team_body_level = /** @type {(inputs: Push_Team_Body_LevelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.chore}, +${i?.xp} XP, en bereikte level ${i?.level}`)
};

export const push_team_title = /** @type {(inputs: Push_Team_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} heeft een klusje gedaan`)
};

export const push_test_body = /** @type {(inputs: Push_Test_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zo ziet je dagelijkse herinnering eruit.`)
};

export const push_test_title = /** @type {(inputs: Push_Test_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meldingen staan aan`)
};

export const push_timer_dishwasher_body = /** @type {(inputs: Push_Timer_Dishwasher_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schone vaat, klaar om op te ruimen.`)
};

export const push_timer_dishwasher_title = /** @type {(inputs: Push_Timer_Dishwasher_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De vaatwasser is klaar`)
};

export const push_timer_dryer_body = /** @type {(inputs: Push_Timer_Dryer_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vouw hem warm op: minder kreukels.`)
};

export const push_timer_dryer_title = /** @type {(inputs: Push_Timer_Dryer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De droger is klaar`)
};

export const push_timer_other_body = /** @type {(inputs: Push_Timer_Other_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De tijd is om.`)
};

export const push_timer_other_title = /** @type {(inputs: Push_Timer_Other_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je timer is klaar`)
};

export const push_timer_oven_body = /** @type {(inputs: Push_Timer_Oven_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Even kijken voordat het aanbrandt.`)
};

export const push_timer_oven_title = /** @type {(inputs: Push_Timer_Oven_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De oventimer is klaar`)
};

export const push_timer_washer_body = /** @type {(inputs: Push_Timer_Washer_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tijd om de was op te hangen voordat hij muf wordt.`)
};

export const push_timer_washer_title = /** @type {(inputs: Push_Timer_Washer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De wasmachine is klaar`)
};

export const push_trade_accepted = /** @type {(inputs: Push_Trade_AcceptedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ruilt mee`)
};

export const push_trade_accepted_body = /** @type {(inputs: Push_Trade_Accepted_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Jouw klusje vandaag: ${i?.chore}`)
};

export const push_trade_body = /** @type {(inputs: Push_Trade_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hun ${i?.give} voor jouw ${i?.get}`)
};

export const push_trade_declined = /** @type {(inputs: Push_Trade_DeclinedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} houdt het eigen klusje`)
};

export const push_trade_declined_body = /** @type {(inputs: Push_Trade_Declined_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Jij houdt: ${i?.chore}`)
};

export const push_trade_title = /** @type {(inputs: Push_Trade_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} wil klusjes ruilen`)
};

export const push_unsupported = /** @type {(inputs: Push_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze browser ondersteunt geen meldingen.`)
};

export const push_unsupported_here = /** @type {(inputs: Push_Unsupported_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze browser kan geen meldingen tonen`)
};

export const q_bathrooms = /** @type {(inputs: Q_BathroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoeveel badkamers?`)
};

export const q_home_type = /** @type {(inputs: Q_Home_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat voor woning?`)
};

export const q_pets = /** @type {(inputs: Q_PetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huisdieren?`)
};

export const q_spaces = /** @type {(inputs: Q_SpacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welke hiervan heb je?`)
};

export const q_things = /** @type {(inputs: Q_ThingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat heb je in huis?`)
};

export const q_toilet = /** @type {(inputs: Q_ToiletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waar is het toilet?`)
};

export const rarity_common = /** @type {(inputs: Rarity_CommonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewoon`)
};

export const rarity_epic = /** @type {(inputs: Rarity_EpicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Episch`)
};

export const rarity_legendary = /** @type {(inputs: Rarity_LegendaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legendarisch`)
};

export const rarity_rare = /** @type {(inputs: Rarity_RareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeldzaam`)
};

export const rebalance = /** @type {(inputs: RebalanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afstemmen`)
};

export const rebalance_confirm_title = /** @type {(inputs: Rebalance_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klussenlijst opnieuw afstemmen?`)
};

export const rebalance_sub = /** @type {(inputs: Rebalance_SubInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zet standaardklusjes aan of uit zodat ze passen bij ${i?.people}. Je eigen klusjes blijven zoals ze zijn.`)
};

export const rebalance_title = /** @type {(inputs: Rebalance_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klussenlijst afstemmen`)
};

export const recap_household_chores = /** @type {(inputs: Recap_Household_ChoresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huishouden`)
};

export const recap_row = /** @type {(inputs: Recap_RowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.total} klusjes deze week, ${i?.mine} door jou`)
};

export const recap_row_solo = /** @type {(inputs: Recap_Row_SoloInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.mine} klusjes deze week`)
};

export const recap_subtitle = /** @type {(inputs: Recap_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De afgelopen 7 dagen, vergeleken met de week ervoor.`)
};

export const recap_title = /** @type {(inputs: Recap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jullie week`)
};

export const recap_top = /** @type {(inputs: Recap_TopInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("nl", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.name} deed het meest: ${i?.count} klusje`);
	return /** @type {LocalizedString} */ (`${i?.name} deed het meest: ${i?.count} klusjes`)
	
};

export const recap_your_chores = /** @type {(inputs: Recap_Your_ChoresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jouw klusjes`)
};

export const reload = /** @type {(inputs: ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herladen`)
};

export const remind_me_at = /** @type {(inputs: Remind_Me_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herinner me om`)
};

export const reminder_body = /** @type {(inputs: Reminder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Krijg elke dag een melding met je klusje.`)
};

export const reminder_cta = /** @type {(inputs: Reminder_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Krijg een dagelijkse herinnering`)
};

export const reminder_cta_sub = /** @type {(inputs: Reminder_Cta_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elke dag een melding met je klusje`)
};

export const reminder_set = /** @type {(inputs: Reminder_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Herinnering ingesteld op ${i?.time}`)
};

export const reminder_title = /** @type {(inputs: Reminder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dagelijkse herinnering`)
};

export const reminders = /** @type {(inputs: RemindersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herinneringen`)
};

export const remove = /** @type {(inputs: RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwijderen`)
};

export const repeats = /** @type {(inputs: RepeatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herhaalt`)
};

export const rescue_bonus = /** @type {(inputs: Rescue_BonusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`reddingsbonus`)
};

export const rest_day_body = /** @type {(inputs: Rest_Day_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vandaag geen klusje, en je reeks blijft staan. Geniet ervan.`)
};

export const rest_day_title = /** @type {(inputs: Rest_Day_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rustdag`)
};

export const review_chores = /** @type {(inputs: Review_ChoresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eerst de klusjes bekijken`)
};

export const rhythm_change = /** @type {(inputs: Rhythm_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aanpassen`)
};

export const rhythm_changed = /** @type {(inputs: Rhythm_ChangedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.chore} is nu ${i?.freq}`)
};

export const rhythm_early = /** @type {(inputs: Rhythm_EarlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.chore} wordt meestal al gedaan voordat het nodig is.`)
};

export const rhythm_keep = /** @type {(inputs: Rhythm_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zo laten`)
};

export const rhythm_label = /** @type {(inputs: Rhythm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ritmetip`)
};

export const rhythm_late = /** @type {(inputs: Rhythm_LateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.chore} wordt meestal pas een flink stuk na de planning gedaan.`)
};

export const rhythm_question = /** @type {(inputs: Rhythm_QuestionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.new} in plaats van ${i?.old}?`)
};

export const rhythm_skipped = /** @type {(inputs: Rhythm_SkippedInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("nl", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.chore} is laatst één keer overgeslagen.`);
	return /** @type {LocalizedString} */ (`${i?.chore} is laatst ${i?.count} keer overgeslagen.`)
	
};

export const room = /** @type {(inputs: RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruimte`)
};

export const room_bathroom = /** @type {(inputs: Room_BathroomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Badkamer`)
};

export const room_bathroom_2 = /** @type {(inputs: Room_Bathroom_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Badkamer 2`)
};

export const room_bathroom_3 = /** @type {(inputs: Room_Bathroom_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Badkamer 3`)
};

export const room_bedroom = /** @type {(inputs: Room_BedroomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slaapkamer`)
};

export const room_buy_body = /** @type {(inputs: Room_Buy_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} munten. Het gaat meteen de kamer van ${i?.pet} in.`)
};

export const room_dining_room = /** @type {(inputs: Room_Dining_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eethoek`)
};

export const room_garage = /** @type {(inputs: Room_GarageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Garage`)
};

export const room_guest_room = /** @type {(inputs: Room_Guest_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logeerkamer`)
};

export const room_hallway = /** @type {(inputs: Room_HallwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gang en trap`)
};

export const room_intro = /** @type {(inputs: Room_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spaar voor meubels. Eén ding per plek; tik op iets van jou om het weg te zetten of terug te plaatsen.`)
};

export const room_kitchen = /** @type {(inputs: Room_KitchenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keuken`)
};

export const room_laundry_room = /** @type {(inputs: Room_Laundry_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Washok`)
};

export const room_living_room = /** @type {(inputs: Room_Living_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Woonkamer`)
};

export const room_name = /** @type {(inputs: Room_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naam van de ruimte`)
};

export const room_office = /** @type {(inputs: Room_OfficeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Werkkamer`)
};

export const room_outdoors = /** @type {(inputs: Room_OutdoorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buiten`)
};

export const room_pets = /** @type {(inputs: Room_PetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huisdieren`)
};

export const room_placed = /** @type {(inputs: Room_PlacedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staat in de kamer`)
};

export const room_placeholder = /** @type {(inputs: Room_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Werkkamer`)
};

export const room_row_sub = /** @type {(inputs: Room_Row_SubInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("nl", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`1 meubelstuk`);
	return /** @type {LocalizedString} */ (`${i?.count} meubelstukken`)
	
};

export const room_tap_to_place = /** @type {(inputs: Room_Tap_To_PlaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tik om te plaatsen`)
};

export const room_title = /** @type {(inputs: Room_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kamer van ${i?.pet}`)
};

export const room_toilet = /** @type {(inputs: Room_ToiletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toilet`)
};

export const room_whole_house = /** @type {(inputs: Room_Whole_HouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hele huis`)
};

export const save = /** @type {(inputs: SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opslaan`)
};

export const save_date = /** @type {(inputs: Save_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opslaan`)
};

export const saved = /** @type {(inputs: SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opgeslagen`)
};

export const schedule_hint = /** @type {(inputs: Schedule_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tik op een dag om te wisselen tussen 1 klusje, 2 klusjes en een rustdag. Rustdagen breken je reeks nooit.`)
};

export const schedule_saved = /** @type {(inputs: Schedule_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Week opgeslagen`)
};

export const seasonal = /** @type {(inputs: SeasonalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seizoensgebonden`)
};

export const seasonal_sub = /** @type {(inputs: Seasonal_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alleen in bepaalde maanden voorstellen`)
};

export const sections = /** @type {(inputs: SectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onderdelen`)
};

export const see_all = /** @type {(inputs: See_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alle ${i?.count} bekijken`)
};

export const select_all_that_apply = /** @type {(inputs: Select_All_That_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kies alles wat klopt`)
};

export const settings = /** @type {(inputs: SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instellingen`)
};

export const setup_body = /** @type {(inputs: Setup_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Voor een huishouden van ${i?.people} staan er ${i?.active} klusjes aan. Dat is ongeveer ${i?.perDay} per dag om te verdelen. Er staan er nog ${i?.more} klaar om aan te zetten wanneer je wilt.`)
};

export const setup_body_solo = /** @type {(inputs: Setup_Body_SoloInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Voor jou alleen staan er ${i?.active} klusjes aan. Dat is ongeveer ${i?.perDay} per dag. Er staan er nog ${i?.more} klaar om aan te zetten wanneer je wilt.`)
};

export const setup_title = /** @type {(inputs: Setup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je klussenlijst staat klaar`)
};

export const share_invite = /** @type {(inputs: Share_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uitnodiging delen`)
};

export const shop_intro = /** @type {(inputs: Shop_IntroInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Elk klusje levert munten op. Kleed ${i?.pet} aan, één ding per plek.`)
};

export const shop_outfits = /** @type {(inputs: Shop_OutfitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outfits`)
};

export const shop_owned = /** @type {(inputs: Shop_OwnedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tik om te dragen`)
};

export const shop_row_sub = /** @type {(inputs: Shop_Row_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outfits en bevriezers`)
};

export const shop_title = /** @type {(inputs: Shop_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maatjeswinkel`)
};

export const shop_to_go = /** @type {(inputs: Shop_To_GoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nog ${i?.count}`)
};

export const shop_wearing = /** @type {(inputs: Shop_WearingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draagt`)
};

export const show_earned = /** @type {(inputs: Show_EarnedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verdiende tonen`)
};

export const show_inactive = /** @type {(inputs: Show_InactiveInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("nl", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} uitgeschakeld klusje tonen`);
	return /** @type {LocalizedString} */ (`${i?.count} uitgeschakelde klusjes tonen`)
	
};

export const show_more = /** @type {(inputs: Show_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meer tonen`)
};

export const sign_in = /** @type {(inputs: Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inloggen`)
};

export const sign_out_device = /** @type {(inputs: Sign_Out_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit apparaat uitloggen`)
};

export const sign_out_here = /** @type {(inputs: Sign_Out_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uitloggen op dit apparaat`)
};

export const signed_in = /** @type {(inputs: Signed_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingelogd`)
};

export const slip_body = /** @type {(inputs: Slip_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} heeft het verdiend en mag nu gaan halen:`)
};

export const slip_ok = /** @type {(inputs: Slip_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geniet ervan!`)
};

export const slip_signed = /** @type {(inputs: Slip_SignedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Getekend, ${i?.pet}`)
};

export const slip_title = /** @type {(inputs: Slip_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toestemmingsbriefje`)
};

export const someone = /** @type {(inputs: SomeoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iemand`)
};

export const start_break = /** @type {(inputs: Start_BreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pauze starten`)
};

export const stat_chores = /** @type {(inputs: Stat_ChoresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klusjes`)
};

export const stat_freezes = /** @type {(inputs: Stat_FreezesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bevriezers`)
};

export const stat_streak = /** @type {(inputs: Stat_StreakInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Reeks · beste ${i?.best}`)
};

export const step_add = /** @type {(inputs: Step_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stap toevoegen`)
};

export const step_delete = /** @type {(inputs: Step_DeleteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} verwijderen`)
};

export const step_done_by = /** @type {(inputs: Step_Done_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gedaan door ${i?.name}`)
};

export const step_n = /** @type {(inputs: Step_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Stap ${i?.n}`)
};

export const step_of = /** @type {(inputs: Step_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Stap ${i?.step} van ${i?.total}`)
};

export const step_placeholder = /** @type {(inputs: Step_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De planken uitzoeken`)
};

export const step_remove = /** @type {(inputs: Step_RemoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Stap ${i?.n} weghalen`)
};

export const step_up_next = /** @type {(inputs: Step_Up_NextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Volgende · ${i?.minutes} min`)
};

export const sticker_bird = /** @type {(inputs: Sticker_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vroege Vogel`)
};

export const sticker_bucket = /** @type {(inputs: Sticker_BucketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trouwe Emmer`)
};

export const sticker_cat = /** @type {(inputs: Sticker_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opzichterskat`)
};

export const sticker_crown = /** @type {(inputs: Sticker_CrownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kroon der Netheid`)
};

export const sticker_fish = /** @type {(inputs: Sticker_FishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schoon Aquarium`)
};

export const sticker_flower = /** @type {(inputs: Sticker_FlowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verse Bloemen`)
};

export const sticker_label = /** @type {(inputs: Sticker_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rarity} sticker`)
};

export const sticker_lamp = /** @type {(inputs: Sticker_LampInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Knusse Lamp`)
};

export const sticker_lemon = /** @type {(inputs: Sticker_LemonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Citroenfris`)
};

export const sticker_plant = /** @type {(inputs: Sticker_PlantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blije Plant`)
};

export const sticker_rainbow = /** @type {(inputs: Sticker_RainbowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strepenvrije Regenboog`)
};

export const sticker_robot = /** @type {(inputs: Sticker_RobotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Robotstofzuiger`)
};

export const sticker_shirt = /** @type {(inputs: Sticker_ShirtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frisse Was`)
};

export const sticker_soap = /** @type {(inputs: Sticker_SoapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handzeep`)
};

export const sticker_sparkles = /** @type {(inputs: Sticker_SparklesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glinsters`)
};

export const sticker_sponge = /** @type {(inputs: Sticker_SpongeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bubbelbad`)
};

export const sticker_spray = /** @type {(inputs: Sticker_SprayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprayflacon`)
};

export const sticker_tea = /** @type {(inputs: Sticker_TeaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welverdiende Thee`)
};

export const sticker_wand = /** @type {(inputs: Sticker_WandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toverstaf`)
};

export const sticker_washer = /** @type {(inputs: Sticker_WasherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centrifuge`)
};

export const stickers = /** @type {(inputs: StickersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stickers`)
};

export const stickers_found = /** @type {(inputs: Stickers_FoundInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.owned} van ${i?.total} gevonden`)
};

export const stickers_hint = /** @type {(inputs: Stickers_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afgeronde klusjes leveren soms een sticker op, bonusklusjes vaker.`)
};

export const streak_days = /** @type {(inputs: Streak_DaysInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("nl", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} dag op rij`);
	return /** @type {LocalizedString} */ (`${i?.count} dagen op rij`)
	
};

export const supplies = /** @type {(inputs: SuppliesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voorraad`)
};

export const supplies_add = /** @type {(inputs: Supplies_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toevoegen`)
};

export const supplies_added_by = /** @type {(inputs: Supplies_Added_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Toegevoegd door ${i?.name}`)
};

export const supplies_bought = /** @type {(inputs: Supplies_BoughtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gekocht`)
};

export const supplies_clear = /** @type {(inputs: Supplies_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wissen`)
};

export const supplies_empty = /** @type {(inputs: Supplies_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niets op de lijst. Zet erop wat bijna op is.`)
};

export const supplies_placeholder = /** @type {(inputs: Supplies_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afwasmiddel, vuilniszakken…`)
};

export const supplies_sub = /** @type {(inputs: Supplies_SubInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("nl", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} ding te kopen`);
	return /** @type {LocalizedString} */ (`${i?.count} dingen te kopen`)
	
};

export const supplies_sub_empty = /** @type {(inputs: Supplies_Sub_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iets bijna op?`)
};

export const swap = /** @type {(inputs: SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wisselen`)
};

export const swapped = /** @type {(inputs: SwappedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewisseld`)
};

export const switched_off_body = /** @type {(inputs: Switched_Off_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze worden nooit gekozen. Zet er een aan en hij doet weer mee.`)
};

export const switched_off_empty = /** @type {(inputs: Switched_Off_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alles staat aan.`)
};

export const switched_off_title = /** @type {(inputs: Switched_Off_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uitgeschakelde klusjes`)
};

export const tab_chores = /** @type {(inputs: Tab_ChoresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klusjes`)
};

export const tab_house = /** @type {(inputs: Tab_HouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huis`)
};

export const tab_profile = /** @type {(inputs: Tab_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profiel`)
};

export const tab_today = /** @type {(inputs: Tab_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vandaag`)
};

export const take_bonus = /** @type {(inputs: Take_BonusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pak een bonusklusje`)
};

export const take_break = /** @type {(inputs: Take_BreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pauze nemen`)
};

export const take_break_sub = /** @type {(inputs: Take_Break_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vakantie of ziek: geen klusjes, reeks blijft staan`)
};

export const takes_about = /** @type {(inputs: Takes_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duurt ongeveer`)
};

export const tap_to_continue = /** @type {(inputs: Tap_To_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tik om verder te gaan`)
};

export const test = /** @type {(inputs: TestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test`)
};

export const test_none = /** @type {(inputs: Test_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen apparaten bereikt. Zet meldingen opnieuw aan.`)
};

export const test_sent = /** @type {(inputs: Test_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testmelding verstuurd`)
};

export const this_device = /** @type {(inputs: This_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(dit apparaat)`)
};

export const timer = /** @type {(inputs: TimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timer`)
};

export const timer_clear = /** @type {(inputs: Timer_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geleegd`)
};

export const timer_done_at = /** @type {(inputs: Timer_Done_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Klaar om ${i?.time}`)
};

export const timer_finished_at = /** @type {(inputs: Timer_Finished_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Klaar sinds ${i?.time}`)
};

export const timer_go = /** @type {(inputs: Timer_GoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} minuten. Gaan!`)
};

export const timer_how_long = /** @type {(inputs: Timer_How_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe lang`)
};

export const timer_intro = /** @type {(inputs: Timer_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iedereen thuis ziet hem, en jij krijgt een melding als hij klaar is.`)
};

export const timer_intro_no_push = /** @type {(inputs: Timer_Intro_No_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iedereen thuis ziet hem. Zet meldingen aan in Instellingen voor een seintje als hij klaar is.`)
};

export const timer_kind_dishwasher = /** @type {(inputs: Timer_Kind_DishwasherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaatwasser`)
};

export const timer_kind_dryer = /** @type {(inputs: Timer_Kind_DryerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Droger`)
};

export const timer_kind_other = /** @type {(inputs: Timer_Kind_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iets anders`)
};

export const timer_kind_oven = /** @type {(inputs: Timer_Kind_OvenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oven`)
};

export const timer_kind_washer = /** @type {(inputs: Timer_Kind_WasherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wasmachine`)
};

export const timer_machine = /** @type {(inputs: Timer_MachineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apparaat`)
};

export const timer_minutes = /** @type {(inputs: Timer_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minuten`)
};

export const timer_new = /** @type {(inputs: Timer_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wastimer`)
};

export const timer_new_sub = /** @type {(inputs: Timer_New_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wasmachine, droger, vaatwasser: een seintje als hij klaar is`)
};

export const timer_pause = /** @type {(inputs: Timer_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pauzeren`)
};

export const timer_restart = /** @type {(inputs: Timer_RestartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opnieuw`)
};

export const timer_resume = /** @type {(inputs: Timer_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verder`)
};

export const timer_start = /** @type {(inputs: Timer_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starten`)
};

export const timer_start_at = /** @type {(inputs: Timer_Start_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Starten · klaar om ${i?.time}`)
};

export const timer_stop = /** @type {(inputs: Timer_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timer stoppen`)
};

export const timers_title = /** @type {(inputs: Timers_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apparaten`)
};

export const times_up = /** @type {(inputs: Times_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De tijd is om.`)
};

export const today = /** @type {(inputs: TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vandaag`)
};

export const toilet_in_bathroom = /** @type {(inputs: Toilet_In_BathroomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In de badkamer`)
};

export const toilet_separate = /** @type {(inputs: Toilet_SeparateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apart`)
};

export const trade = /** @type {(inputs: TradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruilen`)
};

export const trade_accept = /** @type {(inputs: Trade_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruilen`)
};

export const trade_ask = /** @type {(inputs: Trade_AskInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vraag het ${i?.name}`)
};

export const trade_decline = /** @type {(inputs: Trade_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee, dank je`)
};

export const trade_done = /** @type {(inputs: Trade_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geruild! Veel plezier met je nieuwe klusje.`)
};

export const trade_incoming = /** @type {(inputs: Trade_IncomingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} wil ruilen`)
};

export const trade_sent = /** @type {(inputs: Trade_SentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} gevraagd`)
};

export const trade_theirs = /** @type {(inputs: Trade_TheirsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Van hen`)
};

export const trade_title = /** @type {(inputs: Trade_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ruilen met ${i?.name}?`)
};

export const trade_waiting = /** @type {(inputs: Trade_WaitingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wachten op ${i?.name}`)
};

export const trade_you_get = /** @type {(inputs: Trade_You_GetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jij krijgt`)
};

export const trade_you_give = /** @type {(inputs: Trade_You_GiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jij geeft`)
};

export const trade_yours = /** @type {(inputs: Trade_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Van jou`)
};

export const treat_add = /** @type {(inputs: Treat_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traktatie toevoegen`)
};

export const treat_name_label = /** @type {(inputs: Treat_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traktatie`)
};

export const treat_name_placeholder = /** @type {(inputs: Treat_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieuwe plant`)
};

export const treat_price_label = /** @type {(inputs: Treat_Price_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Munten`)
};

export const treat_redeem = /** @type {(inputs: Treat_RedeemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trakteer jezelf`)
};

export const treats_earned = /** @type {(inputs: Treats_EarnedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verdiend`)
};

export const treats_empty = /** @type {(inputs: Treats_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen traktaties. Wat wil je verdienen?`)
};

export const treats_intro = /** @type {(inputs: Treats_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dingen die je wilt verdienen, betaald met munten. Kun je er een betalen, dan krijg je een toestemmingsbriefje.`)
};

export const treats_row_sub = /** @type {(inputs: Treats_Row_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Echte beloningen voor je munten`)
};

export const treats_title = /** @type {(inputs: Treats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traktaties`)
};

export const try_again = /** @type {(inputs: Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opnieuw proberen`)
};

export const turn_on = /** @type {(inputs: Turn_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aanzetten`)
};

export const turn_on_reminders = /** @type {(inputs: Turn_On_RemindersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herinneringen aanzetten`)
};

export const tz_note = /** @type {(inputs: Tz_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Herinneringen gebruiken ${i?.tz}.`)
};

export const tz_switch = /** @type {(inputs: Tz_SwitchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Overschakelen naar ${i?.tz}`)
};

export const verdict_balanced = /** @type {(inputs: Verdict_BalancedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In balans`)
};

export const verdict_tight = /** @type {(inputs: Verdict_TightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Krap`)
};

export const verdict_too_much = /** @type {(inputs: Verdict_Too_MuchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Te veel`)
};

export const weather = /** @type {(inputs: WeatherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weer`)
};

export const weather_intro = /** @type {(inputs: Weather_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ramen, het balkon en de tuin worden bewaard voor een droge dag. De voorspelling komt van Open-Meteo, en alleen je woonplaats wordt gebruikt.`)
};

export const weather_none = /** @type {(inputs: Weather_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen plaatsen gevonden.`)
};

export const weather_remove = /** @type {(inputs: Weather_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weer niet gebruiken`)
};

export const weather_search = /** @type {(inputs: Weather_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plaats of stad`)
};

export const weather_sub_off = /** @type {(inputs: Weather_Sub_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buitenklusjes bewaren voor droge dagen`)
};

export const weather_sub_on = /** @type {(inputs: Weather_Sub_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.place}: buitenklusjes op droge dagen`)
};

export const weather_title = /** @type {(inputs: Weather_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waar woon je?`)
};

export const welcome_create = /** @type {(inputs: Welcome_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huishouden aanmaken`)
};

export const welcome_join = /** @type {(inputs: Welcome_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meedoen met een uitnodigingscode`)
};

export const welcome_link = /** @type {(inputs: Welcome_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inloggen met een apparaatcode`)
};

export const who_does_it = /** @type {(inputs: Who_Does_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie doet het`)
};

export const who_does_it_hint = /** @type {(inputs: Who_Does_It_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kies iemand om dit zijn of haar klusje te maken. Alleen die persoon krijgt het dan.`)
};

export const xp_until_grows = /** @type {(inputs: Xp_Until_GrowsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.xp} / ${i?.next} XP tot ${i?.name} groeit`)
};

export const yay = /** @type {(inputs: YayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Joepie!`)
};

export const year_days = /** @type {(inputs: Year_DaysInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("nl", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`op ${i?.count} dag`);
	return /** @type {LocalizedString} */ (`op ${i?.count} verschillende dagen`)
	
};

export const year_empty = /** @type {(inputs: Year_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen klusjes dit jaar. Het verhaal begint met je eerste!`)
};

export const year_end = /** @type {(inputs: Year_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Op naar volgend jaar`)
};

export const year_fav = /** @type {(inputs: Year_FavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jouw specialiteit`)
};

export const year_high_fives = /** @type {(inputs: Year_High_FivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`high-fives van huisgenoten`)
};

export const year_intro = /** @type {(inputs: Year_IntroInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.year}, in klusjes`)
};

export const year_intro_sub = /** @type {(inputs: Year_Intro_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tik om te zien hoe het ging`)
};

export const year_month = /** @type {(inputs: Year_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Drukste maand: ${i?.month}`)
};

export const year_pet = /** @type {(inputs: Year_PetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pet} groeide uit tot een ${i?.stage}`)
};

export const year_room = /** @type {(inputs: Year_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jouw kamer`)
};

export const year_row = /** @type {(inputs: Year_RowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Jouw ${i?.year}`)
};

export const year_row_sub = /** @type {(inputs: Year_Row_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jouw jaar in klusjes`)
};

export const year_run = /** @type {(inputs: Year_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dagen op rij`)
};

export const year_run_sub = /** @type {(inputs: Year_Run_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je langste reeks`)
};

export const year_share = /** @type {(inputs: Year_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`van alles wat thuis gedaan is`)
};

export const year_times = /** @type {(inputs: Year_TimesInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("nl", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} keer`);
	return /** @type {LocalizedString} */ (`${i?.count} keer`)
	
};

export const year_total = /** @type {(inputs: Year_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`klusjes gedaan`)
};

export const yesterday = /** @type {(inputs: YesterdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gisteren`)
};

export const you = /** @type {(inputs: YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jij`)
};

export const you_suffix = /** @type {(inputs: You_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(jij)`)
};

export const your_colour = /** @type {(inputs: Your_ColourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je kleur`)
};

export const your_companion = /** @type {(inputs: Your_CompanionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jouw maatje`)
};

export const your_devices = /** @type {(inputs: Your_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je apparaten`)
};

export const your_home = /** @type {(inputs: Your_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je huis`)
};

export const your_home_sub = /** @type {(inputs: Your_Home_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamers, huisdieren en apparaten`)
};

export const your_home_unset = /** @type {(inputs: Your_Home_UnsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beantwoord een paar vragen voor een betere lijst`)
};

export const your_name = /** @type {(inputs: Your_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je naam`)
};

export const your_week = /** @type {(inputs: Your_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jouw week`)
};